import { M3Procesos } from "../Registro/m3-procesos";
import { M3PEncItems } from "../Registro/m3-penc-items";
import { M3PrdGeneral } from "../Maestro/M3PrdGeneral.type";
import * as moment_ from 'moment';
import { M3PDetalleItems, M3PItemsWEB, M3PDetalleCupon } from "../Registro/m3-pdetalle-items";
import { PostServiceM3 } from "../../ConexionSQL/posts.service";
import { M3Data } from "../Data/m3-data";
import { DEFAULT_VALUE_ACCESSOR } from "@angular/forms/src/directives/default_value_accessor";
import { xmlToJsonTF } from "../../Convert/xmlToJSon.class";
import { M3PImpuestos } from "../Registro/m3-p-impuestos";
import { M3Ubicacion } from "../Maestro/Ubicacion/M3Ubicacion.type";
import { M3ENCPROMO } from "../Promociones/Models/M3ENCPROMO.class";
import { TypeM3PrdGrp } from "../Maestro/M3PrdGrp.type";
import { promocionesService } from "../Promociones/promociones.service";
import { PromocionProcesada, PromocionesAsociadas, PromocionCombinada } from "../Promociones/Models/M3PromoProcesada.class";
import { M3CouchMaestro } from "../Data/m3-couch-maestro";
import { ServiceM3Maestro } from "./M3Maestro.service";
import { M3PDinamicas } from "../Registro/m3-pdinamicas";
import { ServiceListaPrecio } from "./m3-lista-precio.service";
import { ServiceLoadListaPrecio } from "./m3-load-l-precio.service";
import { a } from "@angular/core/src/render3";
import { M3Presentaciones } from "../Maestro/m3-presentaciones";
import { stringify } from "@angular/compiler/src/util";
import { M3PrdPackDet } from "../Maestro/M3PrdPackDet";
import { M3PrdAdicionales } from "../Maestro/M3PrdAdicionales.type";
import { M3OtClasificaciones } from "../Registro/m3-ot-clasificaciones";
import { M3PrdLista } from "../Maestro/M3PrdLista.type";
import { MathTF } from "../Miscelanea/MathTF.class";
import { ECANCELED } from "constants";

const moment = moment_;
var bigDecimal = require('js-big-decimal');

export class M3RegService {
    public oMathTF: MathTF = new MathTF();
    private oM3CouchMaestro: M3CouchMaestro;
    public oListaObsequios: Array<any> = null;
    public obsequiosExc: boolean = false;
    public obsequioOPromo: number = -1;
    public obsequiosCantidad: number = 0;
    private GoPostServiceM3: PostServiceM3;
    private gsIdkatios;

    constructor(ioM3CouchMaestro: M3CouchMaestro, IsPostServiceM3: PostServiceM3, sIdkatios: string) {
        this.oM3CouchMaestro = ioM3CouchMaestro;
        this.GoPostServiceM3 = IsPostServiceM3;
        this.gsIdkatios = sIdkatios;
    }

    /**
   * Validar numero de items agregados. si es mayor a 1.000 prende parametro 
   */
    public ValidarNumeroItems(olM3Procesos: M3Procesos) {
        if (olM3Procesos.M3ENC.length > 1000) {
            olM3Procesos.AplDesdeServer = true;
            olM3Procesos.M3ENC = new Array<M3PEncItems>();
        }
    }

    public ProcesamientoService(sIDKatios: string, PostServiceM3: PostServiceM3, oM3Procesos: M3Procesos,
        oDataUser: any, funcionOK: Function, funcionError: Function, aplRetomarInfo: boolean = true) {
        this.ValidarNumeroItems(oM3Procesos);
        this.RetomarInformacion(oDataUser, oM3Procesos, aplRetomarInfo);

        PostServiceM3.postServiceHttpResFullM3("M3/RegistroEventoM3/" + sIDKatios + "/" + oDataUser.UsuarioSistema.NDOC + "/" + oDataUser.UsuarioSistema.TDOC, oM3Procesos).subscribe(resp => {
            var oJson = JSON.parse(resp.json());
            oM3Procesos.IdM3 = oJson.RESPUESTA.IDM3;
            oM3Procesos.IDDiario = oJson.RESPUESTA.IDDIARIO;
            oM3Procesos.IDDiarioCierre = oJson.RESPUESTA.IDDIARIOCIERRE

            //Actualizacion de estados.
            oM3Procesos.SubEstadoAnt = oM3Procesos.SubEstadoDes;
            oM3Procesos.EstadoAnt = oM3Procesos.EstadoDes;

            funcionOK(oM3Procesos, oJson.RESPUESTA);
        },
            err => {
                //this.enProceso = false;
                console.error(err.json().Message);
                funcionError(err.json().Message);
            });
    }

    public async procesamiento_service_async(sIDKatios: string, PostServiceM3: PostServiceM3, oM3Procesos: M3Procesos,
        oDataUser: any, aplRetomarInfo: boolean = true) {
        try {
            this.RetomarInformacion(oDataUser, oM3Procesos, aplRetomarInfo);

            var resp = await PostServiceM3.postServiceHttpResFullM3("M3/RegistroEventoM3/" + sIDKatios + "/" + oDataUser.UsuarioSistema.NDOC + "/" + oDataUser.UsuarioSistema.TDOC, oM3Procesos).toPromise();
            var oJson = JSON.parse(resp.json());
            oM3Procesos.IdM3 = oJson.RESPUESTA.IDM3;
            oM3Procesos.IDDiario = oJson.RESPUESTA.IDDIARIO;

            //Actualizacion de estados.
            oM3Procesos.SubEstadoAnt = oM3Procesos.SubEstadoDes;
            oM3Procesos.EstadoAnt = oM3Procesos.EstadoDes;

            return oM3Procesos;
        }
        catch {
            return null;
        }
    }


    public async RegistroEventoM3OffLine(sIDKatios: string, PostServiceM3: PostServiceM3, oM3Procesos: Array<M3Procesos>, oDataUser: any) {
        try {
            await PostServiceM3.postServiceHttpResFullM3("M3/RegistroEventoM3OffLine/" + sIDKatios + "/" + oDataUser.UsuarioSistema.NDOC + "/" + oDataUser.UsuarioSistema.TDOC, oM3Procesos).toPromise();

            return true;
        }
        catch {
            return null;
        }
    }



    ///Retomar informacion para el proceso.
    public RetomarInformacion(oDataUser: any, oM3Procesos: M3Procesos, aplRetomarInfo: boolean) {
        if (oDataUser != null && oM3Procesos.IdM3 !== undefined && oM3Procesos.IdM3 != null) {
            if (aplRetomarInfo) {
                oM3Procesos.M3FTrabajo.IdHub = oDataUser.UsuarioSistema.IDHUB;
                if (oM3Procesos.M3FTrabajo.IdUbic == undefined || oM3Procesos.M3FTrabajo.IdUbic == 0) {
                    oM3Procesos.M3FTrabajo.IdUbic = oDataUser.UsuarioSistema.UBICACION;
                }
            }
            else {
                oM3Procesos.M3FTrabajo.IdUbic = oM3Procesos.M3FTrabajo.IdUbicPre
                oM3Procesos.M3FTrabajo.IdHub = oM3Procesos.M3FTrabajo.IdHubPre;
            }
        }
    }

    //Procesamiento de datos en base de datos pouchDB.
    public ProcesamientoServicePouchDB(oM3Data: M3Data, oM3PItemsWEB: M3PItemsWEB,
        prodGRPSelected: TypeM3PrdGrp, funcionOK: Function, funcionError: Function, oDataUser: any, sIDKatios: string,
        oM3Ubicacion: M3Ubicacion, oM3ENCPROMO: Array<M3ENCPROMO>, ioM3Procesos: M3Procesos, oM3PDinamicasByActividad: any = null) {

        var oM3Procesos: M3Procesos;
        var sKeyCarrito: string;
        var productUnitSelected: M3PrdGeneral;
        productUnitSelected = prodGRPSelected.LoM3PrdGeneral[0];
        //Obtener key de carrito de compras
        sKeyCarrito = oM3Data.GetKeyCarritoCompras(sIDKatios, oDataUser.UsuarioSistema.TDOC, oDataUser.UsuarioSistema.NDOC, oDataUser.UsuarioSistema.UBICACION, oDataUser.UsuarioSistema.IDHUB);
        //Cargar detalle de items
        //Guardar en BD PouchDB
        oM3Data.GetDataPouchBD(sKeyCarrito).then(async result => {
            oM3Procesos = result;
            let cantidad_actual = this.validarExistaProducto(oM3Procesos.M3ENC, productUnitSelected, oM3PItemsWEB);
            if (cantidad_actual != 0) {
                //let cantidad_actual = this.getCantidad(oM3Procesos, productUnitSelected);
                oM3PItemsWEB.dCantidad = (+cantidad_actual) + +oM3PItemsWEB.dCantidad;

                //let M3Enc = this.get_M3ENC_by_idprd_lote(oM3Procesos, productUnitSelected.SKU, productUnitSelected.LOTE);

                oM3Procesos.M3ENC = oM3Procesos.M3ENC.filter(prod => !(prod.IdProducto == productUnitSelected.SKU && prod.Lote == productUnitSelected.LOTE && !(prod.IdEncPadre > 0)));
                this.RecalcularPrecios(oM3Procesos);
                oM3Procesos = this.LoadM3ProcesoFromData(oM3Procesos, prodGRPSelected, oM3PItemsWEB, oM3Ubicacion, oM3ENCPROMO, oDataUser, oM3PDinamicasByActividad);
                await oM3Data.AddToPouchBDCarritoCompras(sKeyCarrito, oM3Procesos);
                funcionOK(oM3Procesos, oM3PItemsWEB);
            } else {
                oM3Procesos = this.LoadM3ProcesoFromData(oM3Procesos, prodGRPSelected, oM3PItemsWEB, oM3Ubicacion, oM3ENCPROMO, oDataUser, oM3PDinamicasByActividad);
                await oM3Data.AddToPouchBDCarritoCompras(sKeyCarrito, oM3Procesos);
                funcionOK(oM3Procesos, oM3PItemsWEB);
            }

            //console.log(oDataCarritoCompras);
        }, async error => {
            if (error.status == "404") {//No existe el carrito 
                oM3Procesos = this.LoadM3ProcesoEmptyPDB(prodGRPSelected, oM3PItemsWEB, oDataUser, oM3Ubicacion, oM3ENCPROMO, ioM3Procesos, oM3PDinamicasByActividad);
                await oM3Data.AddToPouchBDCarritoCompras(sKeyCarrito, oM3Procesos);
                funcionOK(oM3Procesos, oM3PItemsWEB);
            } else {
                console.log("Error no controlado");
                console.log(error);
                funcionError();
            }
        });
    }


    //Agregar a carrito producto.
    public addtocart(oM3PItemsWEB: M3PItemsWEB,
        prodGRPSelected: TypeM3PrdGrp, funcionOK: Function, funcionError: Function, oDataUser: any, sIDKatios: string,
        oM3Ubicacion: M3Ubicacion, oM3ENCPROMO: Array<M3ENCPROMO>, ioM3Procesos: M3Procesos, oM3PDinamicasByActividad: any = null, valorDescuento = 0) {

        var oM3Procesos: M3Procesos = ioM3Procesos;
        var sKeyCarrito: string;
        var productUnitSelected: M3PrdGeneral;
        productUnitSelected = prodGRPSelected.LoM3PrdGeneral[0];
        //JAGM 20190722 se agrega para cuando es el primer producto que se agregarÃ¡
        if (oM3Procesos.M3ENC.length == 0) {
            oM3Procesos = this.LoadM3ProcesoEmptyPDB(prodGRPSelected, oM3PItemsWEB, oDataUser, oM3Ubicacion, oM3ENCPROMO, ioM3Procesos, oM3PDinamicasByActividad);
            if (funcionOK)
                funcionOK(oM3Procesos, oM3PItemsWEB);
            else
                return oM3Procesos;

        } else {
            let cantidad_actual = this.validarExistaProducto(oM3Procesos.M3ENC, productUnitSelected, oM3PItemsWEB);
            if (cantidad_actual != 0) {
                //let cantidad_actual = this.getCantidad(oM3Procesos, productUnitSelected);
                oM3PItemsWEB.dCantidad = (+cantidad_actual) + oM3PItemsWEB.dCantidad;

                oM3Procesos.M3ENC = oM3Procesos.M3ENC.filter(prod => !(prod.IdProducto == productUnitSelected.SKU && prod.Lote == productUnitSelected.LOTE && !(prod.IdEncPadre > 0)));
                this.RecalcularPrecios(oM3Procesos);
                oM3Procesos = this.LoadM3ProcesoFromData(oM3Procesos, prodGRPSelected, oM3PItemsWEB, oM3Ubicacion, oM3ENCPROMO, oDataUser, oM3PDinamicasByActividad, valorDescuento);
                if (funcionOK)
                    funcionOK(oM3Procesos, oM3PItemsWEB);
                else
                    return oM3Procesos;
            } else {
                oM3Procesos = this.LoadM3ProcesoFromData(oM3Procesos, prodGRPSelected, oM3PItemsWEB, oM3Ubicacion, oM3ENCPROMO, oDataUser, oM3PDinamicasByActividad, valorDescuento);
                if (funcionOK)
                    funcionOK(oM3Procesos, oM3PItemsWEB);
                else
                    return oM3Procesos;
            }
        }


    }

    //Valida que exista producto en los encabezados. True: Si existe, False de otro modo
    // Se cambia funcionalidad de return.
    public validarExistaProducto(oM3ListaEnc: Array<M3PEncItems>, oM3PrdGrl: M3PrdGeneral, oM3PItemsWEB: M3PItemsWEB): number {
        var oEnc: M3PEncItems = null;
        var cantidad: number = 0;
        oM3PItemsWEB.IDEncRepetido = -1;
        if (oM3ListaEnc !== undefined && oM3PrdGrl !== undefined && oM3ListaEnc.length > 0) {

            oEnc = oM3ListaEnc.find(enc => enc.IdProducto == oM3PrdGrl.SKU && !enc.IdEncPadre && this.getCantidadPositiva(enc));
            if (oEnc !== undefined && oEnc != null) {
                //JAGM 20190717 Validar ahora el precio.
                this.VerificarPrecioByNivelesGeneral(oM3PrdGrl, +oEnc.M3DET.find(x => x.NombreConcepto == "CANTIDAD").Valor);
                if (this.ValidarPreciosPrds(oEnc, oM3PrdGrl.LoM3PrdLista) && !this.ValidarEstaPaquete(oEnc, oM3ListaEnc)) {
                    oM3PItemsWEB.IDEncRepetido = oEnc.ID;
                    cantidad = +oEnc.M3DET.find(det => det.NombreConcepto == "CANTIDAD").Valor;
                    //return true;
                } else {
                    //return false;
                }
            }
        }
        return cantidad;
    }

    getCantidadPositiva(oM3PEncItems: M3PEncItems): boolean {
        let cantidad = 0;
        let detCantidad = oM3PEncItems.M3DET.find(x => x.NombreConcepto == "CANTIDAD")

        if (detCantidad) {
            cantidad = +detCantidad.Valor;
        }

        if (cantidad > 0) {
            return true;
        }
        else {
            return false;
        }

    }

    /**
     * Valida que el encabezado con el producto agregado, sea un paquete
     * @param oM3PEncItems 
     * @param oM3ListaEnc 
     */
    public ValidarEstaPaquete(oM3PEncItems: M3PEncItems, oM3ListaEnc: Array<M3PEncItems>) {
        var bResp: boolean = false;
        try {
            if (oM3ListaEnc.find(x => x.IdEncPadre == oM3PEncItems.ID)) {
                bResp = true;
            }
        } catch {

        }
        return bResp;
    }

    /**
     * Validar los precios de los productos
     * @param oEnc 
     * @param oM3PrdLista 
     */
    public ValidarPreciosPrds(oEnc: M3PEncItems, oM3PrdLista: M3PrdLista) {
        var bResp: boolean = false;
        try {
            var dPrecioEnc: number = +oEnc.M3DET.find(x => x.NombreConcepto == "PUNIT").Valor;
            var dPrecioList: number = oM3PrdLista.PRECIO;

            if (dPrecioList == dPrecioEnc) {
                bResp = true;
            }


        } catch (ex) {
            console.log("Error ValidarPreciosPrds")
            console.log(ex)
        }
        return bResp;
    }


    //Actualizacion de M3 procesos, con data lista para actualizar.
    public UpdateM3ProcesosWithData(oM3Procesos: M3Procesos, oM3Data: M3Data,
        oDataUser: any, sIDKatios: string, tipoUbicacion: string, funcionOK: Function, funcionError: Function
        , m3Ubicacion: M3Ubicacion = null, oM3PItemsWEB: M3PItemsWEB = null) {
        //Guardar en BD PouchDB
        var sKeyCarrito: string;
        this.RecalcularPrecios(oM3Procesos);
        //Obtener key de carrito de compras
        //IDHUB
        if (tipoUbicacion.toUpperCase() == "WEB") {
            sKeyCarrito = oM3Data.GetKeyCarritoCompras(sIDKatios, oDataUser.UsuarioSistema.TDOC, oDataUser.UsuarioSistema.NDOC, oDataUser.UsuarioSistema.UBICACION, oDataUser.UsuarioSistema.IDHUB);

            oM3Data.GetDataPouchBD(sKeyCarrito).then(result => {
                oM3Data.AddToPouchBDCarritoCompras(sKeyCarrito, oM3Procesos);
                this.procesarPromoAfterCarritoOk(oM3Procesos, oM3Data, oDataUser, m3Ubicacion, funcionOK, funcionError, oM3PItemsWEB);
            }, error => {
                if (error.status == "404") {//No existe el carrito 
                    oM3Data.AddToPouchBDCarritoCompras(sKeyCarrito, oM3Procesos);
                    this.procesarPromoAfterCarritoOk(oM3Procesos, oM3Data, oDataUser, m3Ubicacion, funcionOK, funcionError, oM3PItemsWEB);
                } else {
                    console.log("Error no controlado");
                    funcionError();
                }
            });
        }
    }

    public procesarPromoAfterCarritoOk(oM3Procesos: M3Procesos, oM3Data: M3Data,
        oDataUser: any, m3Ubicacion: M3Ubicacion, funcionOK: Function, funcionError: Function, oM3PItemsWEB: M3PItemsWEB) {
        if (m3Ubicacion) {
            var loM3PItemsWEB: M3PItemsWEB;
            if (oM3PItemsWEB) {
                loM3PItemsWEB = oM3PItemsWEB;
            } else {
                loM3PItemsWEB = new M3PItemsWEB();
                loM3PItemsWEB.dCantidad = 1;
            }

            var sKeyCarrito = oM3Data.GetKeyCarritoCompras(this.gsIdkatios, oDataUser.UsuarioSistema.TDOC, oDataUser.UsuarioSistema.NDOC, oDataUser.UsuarioSistema.UBICACION, oDataUser.UsuarioSistema.IDHUB);
            this.ProcPromoAfterAddToCart(oM3Procesos, oDataUser, loM3PItemsWEB, m3Ubicacion, true).then(x => {
                // console.log(x);
                // console.log(oData);
                oM3Data.AddToPouchBDCarritoComprasAsync(sKeyCarrito, oM3Procesos).then(x => {
                    console.debug("Entro1");
                    funcionOK();
                }).catch(x => {
                    console.debug("Entro2");
                    funcionOK();
                });
            }).catch(x => {
                console.log(x)
                console.log("Error no controlado en procesarPromoAfterCarritoOk");
                funcionOK();
                //   this.oEncabezadoM3Component.RecargarCarrito();
                //   this.LoadCart();
            });
        }
        else {
            funcionOK();
        }
    }


    //Actualizacion de M3 procesos, con data lista para actualizar.
    public updateAPouch(oM3Procesos: M3Procesos, oM3Data: M3Data,
        oDataUser: any, sIDKatios: string, tipoUbicacion: string, funcionOK: Function, funcionError: Function) {
        //Guardar en BD PouchDB
        var sKeyCarrito: string;
        //Obtener key de carrito de compras
        //IDHUB
        if (tipoUbicacion.toUpperCase() == "WEB") {
            sKeyCarrito = oM3Data.GetKeyCarritoCompras(sIDKatios, oDataUser.UsuarioSistema.TDOC, oDataUser.UsuarioSistema.NDOC, oDataUser.UsuarioSistema.UBICACION, oDataUser.UsuarioSistema.IDHUB);

            oM3Data.GetDataPouchBD(sKeyCarrito).then(result => {
                oM3Data.AddToPouchBDCarritoCompras(sKeyCarrito, oM3Procesos);
                funcionOK();
            }, error => {
                if (error.status == "404") {//No existe el carrito 
                    oM3Data.AddToPouchBDCarritoCompras(sKeyCarrito, oM3Procesos);
                    funcionOK();
                } else {
                    console.log("Error no controlado");
                    funcionError();
                }
            });
        }

    }

    public async DeleteM3Proceso(oM3Data: M3Data, oDataUser: any, sIDKatios: string) {
        var sKeyCarrito: string;
        sKeyCarrito = oM3Data.GetKeyCarritoCompras(sIDKatios, oDataUser.UsuarioSistema.TDOC, oDataUser.UsuarioSistema.NDOC, oDataUser.UsuarioSistema.UBICACION, oDataUser.UsuarioSistema.IDHUB);
        await oM3Data.Delete(sKeyCarrito);
    }


    ///Eliminar documento de couch/pouch, inicio y actual
    public DelDocsStartAndCurrent(oM3Data: M3Data, sIDKatios: string, olM3Procesos: M3Procesos, UbicacionCurrent, HubCurrent) {
        //Eliminar Inicial
        if (olM3Procesos.IDDiarioCierre !== undefined && olM3Procesos.IDDiarioCierre != null) {
            var oDataUser = { "UsuarioSistema": { "TDOC": olM3Procesos.TDoc, "NDOC": olM3Procesos.NDoc, "UBICACION": olM3Procesos.Ubic1.toString(), "IDHUB": olM3Procesos.IDHub } }
            this.DeleteM3Proceso(oM3Data, oDataUser, sIDKatios).then(x => {
                console.log("Delete start");
            })

            //Eliminar actual
            oDataUser = { "UsuarioSistema": { "TDOC": olM3Procesos.TDoc, "NDOC": olM3Procesos.NDoc, "UBICACION": UbicacionCurrent.toString(), "IDHUB": HubCurrent } }
            this.DeleteM3Proceso(oM3Data, oDataUser, sIDKatios).then(x => {
                console.log("Delete current");
            })
        }

    }


    //Actualizacion de M3 procesos, con data lista para actualizar.
    public async GetCarritoComprasPouchDB(oM3Data: M3Data, oDataUser: any, sIDKatios: string) {
        //Guardar en BD PouchDB
        var sKeyCarrito: string;
        var oM3Proceso;
        //Obtener key de carrito de compras
        sKeyCarrito = oM3Data.GetKeyCarritoCompras(sIDKatios, oDataUser.UsuarioSistema.TDOC, oDataUser.UsuarioSistema.NDOC, oDataUser.UsuarioSistema.UBICACION, oDataUser.UsuarioSistema.IDHUB);

        oM3Proceso = await oM3Data.GetDataPouchBD(sKeyCarrito);
        return oM3Proceso;
    }

    //Trasladar informaciÃ³n de carrito, dos usuarios
    public async MoveCartIntoUser(sIDKatios: string, oM3Data: M3Data, oDataUserOrigen: any, oDataUserDestino: any, funcionOK: Function) {
        var sKeyCarritoOrigen;
        var sKeyCarritoDestino;

        try {
            sKeyCarritoOrigen = oM3Data.GetKeyCarritoCompras(sIDKatios, oDataUserOrigen.UsuarioSistema.TDOC, oDataUserOrigen.UsuarioSistema.NDOC, oDataUserOrigen.UsuarioSistema.UBICACION, oDataUserOrigen.UsuarioSistema.IDHUB);
            sKeyCarritoDestino = oM3Data.GetKeyCarritoCompras(sIDKatios, oDataUserDestino.UsuarioSistema.TDOC, oDataUserDestino.UsuarioSistema.NDOC, oDataUserDestino.UsuarioSistema.UBICACION, oDataUserDestino.UsuarioSistema.IDHUB);
            let oM3Proceso = await oM3Data.GetDataPouchBD(sKeyCarritoOrigen);

            oM3Proceso.TDoc = oDataUserDestino.UsuarioSistema.TDOC;
            oM3Proceso.NDoc = oDataUserDestino.UsuarioSistema.NDOC;
            delete oM3Proceso["_rev"];
            await oM3Data.AddToPouchBDCarritoCompras(sKeyCarritoDestino, oM3Proceso);
            funcionOK();
        } catch (error) {
            funcionOK();
        }
    }

    /**
     * Recalcular precios totales y de base
     * @param oM3Procesos 
     */
    public RecalcularPreciosPromoCombinada(oM3Procesos: M3Procesos) {
        // var dPrecioTotal;
        // var dPrecioTotalBase;
        // var dValor: number = 0;
        // var dValorNeto: number = 0;


        // oM3Procesos.M3ENC.forEach(enc => {
        //     dPrecioTotal = enc.M3DET.find(det => det.NombreConcepto == "PRECIOTOTAL").Valor //(+enc.M3DET.find(det => det.NombreConcepto == "CANTIDAD").Valor) * (+enc.M3DET.find(det => det.NombreConcepto == "PUNITNETO").Valor);
        //     dPrecioTotalBase = this.CalcularPrecioBaseFromProceso(enc, dPrecioTotal);
        //     enc.M3DET.find(det => det.NombreConcepto == "PRECIOTOTALBASE").Valor = String(Math.round(dPrecioTotalBase * 100) / 100);
        //     dValor = (+dValor) + (+dPrecioTotalBase);
        //     dValorNeto = (+dValorNeto) + (+dPrecioTotal);
        //     this.RecalculoImpuestos(enc, dPrecioTotalBase);
        // });
        // //oM3Procesos.Valor = dValor;
        // oM3Procesos.ValorNeto = dValorNeto;
        this.RecalcularPrecios(oM3Procesos);
    }


    //Recalcular precios. recorriendo los encabezados.
    public RecalcularPrecios(oM3Procesos: M3Procesos) {
        var valor = 0;
        var ValorNeto = 0;
        oM3Procesos.M3ENC.forEach(enc => {
            //JAGM 20191010 se cambia el valor del precio unitario base, ya que al momento de llamar la funciÃ³n ValoresCalculadosProceso
            // se recalculo el precio total, dependiendo de este valor.
            let pTotalBase = this.CalculatePrecioBase(enc.M3DET.find(det => det.NombreConcepto == "CTBLDIMPPRD").Valor,
                this.oMathTF.round(enc.M3DET.find(det => det.NombreConcepto == "PRECIOTOTAL").Valor, 2));

            var dCantidadEnc = +enc.M3DET.find(det => det.NombreConcepto == "CANTIDAD").Valor;
            if (+dCantidadEnc != 0) {
                enc.M3DET.find(det => det.NombreConcepto == "PRECIOUNITBASE").Valor = (+pTotalBase / +enc.M3DET.find(det => det.NombreConcepto == "CANTIDAD").Valor).toString();
            } else {
                enc.M3DET.find(det => det.NombreConcepto == "PRECIOUNITBASE").Valor = "0";
            }





            this.ValoresCalculadosProceso(enc, +enc.M3DET.find(det => det.NombreConcepto == "CANTIDAD").Valor);
        });
        this.recalcularM3Proceso(oM3Procesos);
    }

    //Calcular precio base de un precio, teniendo el valor total o neto.
    public CalcularPrecioBaseFromProceso(oM3PEncItems: M3PEncItems, dPrecioNeto: number) {
        var dValorImpuesto: number = 1;
        try {
            oM3PEncItems.M3PImpuestos.forEach(imp => {
                dValorImpuesto = (+dValorImpuesto) + (+imp.Porcentaje);
            });
        } catch {

        }
        return ((+dPrecioNeto) / (+dValorImpuesto));
    }

    //Recalculo de valor de impuestos, cuando cambia el valor. Sea por cantidad, eliminaciÃ³n...
    // public RecalculoImpuestos(oM3PEncItems: M3PEncItems, dPrecioBase: number) {
    //     var dTotalImpuesto: number = 0;
    //     oM3PEncItems.M3PImpuestos.forEach(imp => {
    //         imp.Valor = (+dPrecioBase) * (+imp.Porcentaje);
    //         //JAGM 20180912 nuevo concepto
    //         imp.Base = dPrecioBase;
    //         dTotalImpuesto = (+dTotalImpuesto) + (+imp.Valor);
    //         //Suma de precio base 
    //         dPrecioBase = (+dPrecioBase) + (+imp.Valor);
    //     });
    //     dTotalImpuesto = Math.round(dTotalImpuesto * 100) / 100;
    //     oM3PEncItems.M3DET.find(det => det.NombreConcepto == "TOTALIMPUESTOS").Valor = dTotalImpuesto.toString();
    // }


    /**
     * Creacion nuevo M3 procesos, este va vacio sin nisiquiera M3PEncItems. 
     * Se utiliza principalmente para las creacion desde 0 un M3 Proceso. Que pasa de estados '' al primer estado
     * @param ioM3Procesos 
     * @param idproceso_destino 
     * @param tdoc 
     * @param ndoc 
     * @param estados_futuros 
     * @param idHub 
     * @param idUbicacion 
     */
    public CreateM3NewProcesoEmpty(ioM3Procesos: M3Procesos, idproceso_destino: string, tdoc: string, ndoc: string,
        estados_futuros: Array<any>, idHub: string, idUbicacion: string) {

        ioM3Procesos.TMIdProceso = idproceso_destino;
        ioM3Procesos.EstadoAnt = "";
        ioM3Procesos.SubEstadoAnt = "";
        ioM3Procesos.EstadoDes = estados_futuros[0].E_Destino;
        ioM3Procesos.SubEstadoDes = estados_futuros[0].SE_Destino;
        ioM3Procesos.M3FTrabajo.IdHub = +idHub;
        ioM3Procesos.M3FTrabajo.IdUbic = +idUbicacion;
        ioM3Procesos.IDHub = +idHub;
        ioM3Procesos.Ubic1 = +idUbicacion;
        ioM3Procesos.TDoc = tdoc;
        ioM3Procesos.NDoc = ndoc;
        ioM3Procesos.TipoTercero = 1;
        ioM3Procesos.Ubic2 = -1;
        ioM3Procesos.M3FTrabajo.IdHubPre = -1;
        ioM3Procesos.M3FTrabajo.IdUbicPre = -1;
    }

    //Cuando se agrega por primera vez al carrito de compra.
    public LoadM3ProcesoEmptyPDB(prodGRPSelected: TypeM3PrdGrp, oM3PItemsWEB: M3PItemsWEB, oDataUser: any, oM3Ubicacion: M3Ubicacion, oM3ENCPROMO: Array<M3ENCPROMO>, ioM3Procesos: M3Procesos, oM3PDinamicasByActividad: any = null): M3Procesos {
        //sIDKatios, oDataUser.UsuarioSistema.TDOC, oDataUser.UsuarioSistema.NDOC, oDataUser.UsuarioSistema.UBICACION
        var oM3Procesos;
        if (ioM3Procesos != null) {
            oM3Procesos = ioM3Procesos;
        } else {
            oM3Procesos = new M3Procesos();
        }

        oM3Procesos.Fecha = moment(new Date()).format('YYYY-MM-DD');
        oM3Procesos.TipoTercero = 1;
        oM3Procesos.TDoc = oDataUser.UsuarioSistema.TDOC;
        oM3Procesos.NDoc = oDataUser.UsuarioSistema.NDOC;
        oM3Procesos.Ubic1 = oDataUser.UsuarioSistema.UBICACION;
        oM3Procesos.Ubic2 = -1;
        ///AGREGAR NUEVA FUNCIONALIDAD DE HUBS. FLUJO DE TRABAJO
        oM3Procesos.IDHub = oDataUser.UsuarioSistema.IDHUB;
        oM3Procesos.M3FTrabajo.IdHub = oM3Procesos.IDHub;
        oM3Procesos.M3FTrabajo.IdUbic = oM3Procesos.Ubic1;

        oM3Procesos.M3FTrabajo.IdHubPre = -1;
        oM3Procesos.M3FTrabajo.IdUbicPre = -1;

        ///FIN AGREGAR NUEVA FUNCIONALIDAD DE HUBS. FLUJO DE TRABAJO

        // oM3Procesos.SubEstadoAnt = "";
        // oM3Procesos.EstadoAnt = "";

        if (oM3Procesos.SubEstadoDes == "" && ioM3Procesos == null) {
            oM3Procesos.SubEstadoDes = "Registro";
            oM3Procesos.EstadoDes = "Activo";
        }

        if (oM3PItemsWEB.SubEstado_o != "" && oM3PItemsWEB.Estado_o != "") {
            oM3Procesos.SubEstadoDes = oM3PItemsWEB.SubEstado_o;
            oM3Procesos.EstadoDes = oM3PItemsWEB.Estado_o;
        }


        if (oM3PItemsWEB.IdProceso == "" && ioM3Procesos == null) {
            oM3Procesos.TMIdProceso = "M3ECC";
        }
        else {
            if (oM3PItemsWEB.IdProceso != "") {
                oM3Procesos.TMIdProceso = oM3PItemsWEB.IdProceso;
            }
        }

        //oM3Procesos.M3ENC.push(this.LoadM3PEncItemsFromPrdGrl(oM3Procesos, prodGRPSelected, oM3Procesos.M3ENC, oM3PItemsWEB, oM3Ubicacion, oM3ENCPROMO, oDataUser));
        this.LoadM3PEncItemsFromPrdGrl(oM3Procesos, prodGRPSelected, oM3Procesos.M3ENC, oM3PItemsWEB, oM3Ubicacion, oM3ENCPROMO, oDataUser, null, 0, oM3PDinamicasByActividad)

        // oM3Procesos.Valor = oM3PItemsWEB.dPrecioTotal;
        // oM3Procesos.ValorNeto = oM3PItemsWEB.dPrecioTotal;

        return oM3Procesos;
        //this.ProcesamientoService(PostServiceM3, oM3Procesos, funcionOK, funcionError);
    }


    //Cargar nuevos adicionales adicionales
    public LoadAdicionales(oM3PItemsWEB: M3PItemsWEB, product: TypeM3PrdGrp): M3PItemsWEB {
        try {
            oM3PItemsWEB.ClavePrdSRV = product.LoM3PrdAdicionales.find(adi => adi.ATRIBUTO == "CLAVEPRODSERV").VALOR;
            oM3PItemsWEB.ClavePrdUnidad = product.LoM3PrdAdicionales.find(adi => adi.ATRIBUTO == "CLAVEUNIDAD").VALOR;
            oM3PItemsWEB.Unidad = product.LoM3PrdAdicionales.find(adi => adi.ATRIBUTO == "UNIDAD").VALOR;
        } catch {

        }
        return oM3PItemsWEB;
    }

    //Cargar procesos, retomando desde data
    public LoadM3ProcesoFromData(oM3Procesos: M3Procesos, prodGRPSelected: TypeM3PrdGrp,
        oM3PItemsWEB: M3PItemsWEB, oM3Ubicacion: M3Ubicacion, oM3ENCPROMO: Array<M3ENCPROMO>, oDataUser: any, oM3PDinamicasByActividad: any = null, valorDescuento = 0): M3Procesos {
        // oM3Procesos.Valor = (+oM3Procesos.Valor) + (+oM3PItemsWEB.dPrecioTotal);
        // oM3Procesos.ValorNeto = oM3Procesos.Valor;
        oM3Procesos.Fecha = moment(new Date()).format('YYYY-MM-DD');
        if (oM3Procesos.TMIdProceso == "" && oM3PItemsWEB.IdProceso != "") {
            oM3Procesos.TMIdProceso = oM3PItemsWEB.IdProceso;
        }

        //oM3Procesos.M3ENC.push(this.LoadM3PEncItemsFromPrdGrl(oM3Procesos, prodGRPSelected, oM3Procesos.M3ENC, oM3PItemsWEB, oM3Ubicacion, oM3ENCPROMO, oDataUser));
        this.LoadM3PEncItemsFromPrdGrl(oM3Procesos, prodGRPSelected, oM3Procesos.M3ENC, oM3PItemsWEB, oM3Ubicacion, oM3ENCPROMO, oDataUser, null, valorDescuento, oM3PDinamicasByActividad)

        return oM3Procesos;
    }

    public LoadM3PEncItemsFromPrdGrl(oM3Procesos: M3Procesos, prodGRPSelected: TypeM3PrdGrp,
        oencabezadoItems: Array<M3PEncItems>, oM3PItemsWEB: M3PItemsWEB,
        oM3Ubicacion: M3Ubicacion, oM3ENCPROMO: Array<M3ENCPROMO>, oDataUser: any, oPadreM3PEncItems: M3PEncItems, valorDescuento = 0, oM3PDinamicasByActividad: any = null) {

        //Validacion de Inventario.
        let adiVentaNeg = prodGRPSelected.LoM3PrdAdicionales.find(x => x.ATRIBUTO == "VENTANEG")
        if (oM3Procesos["InventarioError"]) {
            delete oM3Procesos["InventarioError"];
        }
        if (oM3Procesos.TMIdProceso.toUpperCase() == "M3ECC" && prodGRPSelected.LoM3PrdGeneral[0].DISPONIBLE < oM3PItemsWEB.dCantidad && oM3Ubicacion.M3HUBS[0].Tipo == "WEB" && !(adiVentaNeg && adiVentaNeg.VALOR)) {
            oM3Procesos["InventarioError"] = 'No hay inventario para agregar ' + oM3PItemsWEB.dCantidad + ' Items';
            oM3PItemsWEB.dCantidad = prodGRPSelected.LoM3PrdGeneral[0].DISPONIBLE;
        } //else {

        var oM3PEncItems = new M3PEncItems();
        oM3Procesos.Fecha = moment(new Date()).format('YYYY-MM-DD');
        oM3PEncItems = this.LoadM3PEncItemsFromPrdGrlItem(oM3Procesos, prodGRPSelected, oM3Procesos.M3ENC, oM3PItemsWEB, oM3Ubicacion, oM3ENCPROMO, oDataUser, oPadreM3PEncItems, valorDescuento);

        if (oM3Procesos["MensajeError"]) {
            delete oM3Procesos["MensajeError"];
        }
        if (oPadreM3PEncItems) {
            //Tiene un encabezado padre.
            oM3PEncItems.IdEncPadre = oPadreM3PEncItems.ID;
        }

        if (!oM3PEncItems["MensajeError"]) {
            var olM3PrdPackDet: Array<M3PrdPackDet>;
            olM3PrdPackDet = prodGRPSelected.LoM3PrdGeneral[0].M3PACK
            if (olM3PrdPackDet && olM3PrdPackDet.length > 0) {

                //let valorDescuentoPack = this.calcularPorcentajeDescuentoCombo(prodGRPSelected);

                for (var i = 0; i < olM3PrdPackDet.length; i++) {
                    var oM3PrdPackDet: M3PrdPackDet = olM3PrdPackDet[i];
                    var packM3PItemsWEB: M3PItemsWEB;

                    if (oM3PrdPackDet.oM3PItemsWEB) {
                        packM3PItemsWEB = oM3PrdPackDet.oM3PItemsWEB;
                    }
                    else {
                        packM3PItemsWEB = Object.assign({}, oM3PItemsWEB);
                        packM3PItemsWEB.dCantidad = oM3PrdPackDet.Cantidad;
                    }
                    packM3PItemsWEB.PathImagen = oM3PrdPackDet.gsPathImagen;
                    //this.CalcularPreciosPCKG(oM3PrdPackDet);
                    packM3PItemsWEB.IDEncRepetido = +this.GetMaxAtributoFromLista(oM3Procesos.M3ENC, "ID") + i + 2; //Esto funciona si tiene solo 2 niveles
                    //Si esto se cumple este producto es un pack y tiene productos asociados.
                    oM3PrdPackDet.M3GRP.LoM3PrdGeneral[0].LoM3PrdLista.PRECIO = 0;
                    this.LoadM3PEncItemsFromPrdGrl(oM3Procesos, oM3PrdPackDet.M3GRP, oM3Procesos.M3ENC, packM3PItemsWEB, oM3Ubicacion, oM3ENCPROMO, oDataUser, oM3PEncItems, 0, oM3PDinamicasByActividad);
                }
            }

            //JAGM 20190623, esto es cuando se modifica la cantidad de prodcutos existentes.
            if (oM3PItemsWEB.IDEncRepetido != -1) {
                oM3PEncItems.ID = oM3PItemsWEB.IDEncRepetido;
            }
            //JAGM 2019 envio de padre desde instruccion mas arriba
            if (oM3PItemsWEB.IDEncPadre != -1) {
                oM3PEncItems.IdEncPadre = oM3PItemsWEB.IDEncPadre;
                oM3PEncItems.TipoAgrupacion = oM3PItemsWEB.TipoAgrupacion;
            }
            if (oM3PDinamicasByActividad && oM3PDinamicasByActividad.length > 0) {
                oM3PDinamicasByActividad.forEach(din => {
                    oM3PEncItems.M3PDinamByActividad.push(din);
                });
            }

            oM3Procesos.M3ENC.push(oM3PEncItems);

        }
        else {
            oM3Procesos["MensajeError"] = oM3PEncItems["MensajeError"];
        }
        oM3PItemsWEB.IDEncProcesado = oM3PEncItems.ID;
        //}
    }

    calcularPorcentajeDescuentoCombo(prodGRPSelected: TypeM3PrdGrp) {
        let valorDescuentoPack = 0;
        let valorItemsComboSuma = 0;
        let valorFinalCombo = prodGRPSelected.LoM3PrdGeneral[0].LoM3PrdLista.PRECIO;

        prodGRPSelected.LoM3PrdGeneral[0].M3PACK.forEach(prdPack => {
            let cantidad = prdPack.M3GRP.Cantidad ? prdPack.M3GRP.Cantidad : 1;
            let infNivelesPrcio = this.VerificarPrecioByNiveles(prdPack.M3GRP, cantidad);
            console.debug(prdPack.M3GRP.LoM3PrdGeneral[0].LoM3PrdLista.IDLISTA)
            console.debug(prdPack.M3GRP.LoM3PrdGeneral[0].LoM3PrdLista.PRECIO)
            valorItemsComboSuma += (prdPack.M3GRP.LoM3PrdGeneral[0].LoM3PrdLista.PRECIO * cantidad);
        });

        if (valorItemsComboSuma > valorFinalCombo) {
            valorDescuentoPack = 100 - (valorFinalCombo * 100 / valorItemsComboSuma);
        }
        console.debug(valorDescuentoPack)
        return valorDescuentoPack;
    }


    /**
     * Recalculo de precios de hijos del paquete
     * @param oM3PrdPackDet 
     */
    public CalcularPreciosPCKG(oM3PrdPackDet: M3PrdPackDet) {
        oM3PrdPackDet.M3GRP.LoM3PrdGeneral[0].LoM3PrdLista.PRECIO = 0;
    }

    public loadM3PEncItemsFromPromocionCombo(oM3Procesos: M3Procesos, productosHijosDelCombo: Array<M3PEncItems>, codigo: string, valor, dCantidad: number) {
        let productoCombo = new M3PEncItems();


        productoCombo.IdProducto = codigo;
        productoCombo.Lote = "1";
        productoCombo.ID = +this.GetMaxAtributoFromLista(oM3Procesos.M3ENC, "ID") + 1; //JAGM, cambio de ID, caso cuando se agrega prd:1, prd:2 y de nuevo prd:1. En este caso en lÃ³gica anterior, se hace remove de item. y los ID quedaban repetidos.
        productoCombo.Orden = +this.GetMaxAtributoFromLista(oM3Procesos.M3ENC, "Orden") + 1;
        productoCombo.Nombre = "Combo";


        productoCombo.M3DET.push(this.LoadM3PDetalle(moment(new Date()).format('YYYY-MM-DDTHH:mm:ss'), "FECHAIN"));
        productoCombo.M3DET.push(this.LoadM3PDetalle("true", "ESPRODPROMOCOMBO"));
        productoCombo.M3DET.push(this.LoadM3PDetalle("true", "ESPRODPROMO")); // TRUE-> SI ES UN PRODUCTO POR PROMOCION, FALSE-> DE OTRO MODO
        //Detalles de factura electronica
        productoCombo.M3DET.push(this.LoadM3PDetalle("ENCPROMO", "TIPO_PRD"));
        /**FIN INFORMACION GENERAL */

        //** INICIO VALORES UNITARIOS */
        productoCombo.M3DET.push(this.LoadM3PDetalle(valor, "PRECIOUNITBASE")); //Precio Sin impuestos
        productoCombo.M3DET.push(this.LoadM3PDetalle("0", "TOTALIMPUESTOS"));
        productoCombo.M3DET.push(this.LoadM3PDetalle("0", "TOTALIMPUNIT"));
        productoCombo.M3DET.push(this.LoadM3PDetalle(valor, "PUNITSINIMPUESTO"));//Sin descuento incluido Y sin Impuestos
        productoCombo.M3DET.push(this.LoadM3PDetalle(valor, "PUNIT"));//Sin descuento incluido  ------ Nunca Cambia
        productoCombo.M3DET.push(this.LoadM3PDetalle(valor, "PUNITNETO"));//Con descuento incluido------ Nunca Cambia
        productoCombo.M3DET.push(this.LoadM3PDetalle("0", "VUNITPROMO"));//Unitario Promocion ------ Nunca Cambia
        productoCombo.M3DET.push(this.LoadM3PDetalle("0", "UNITFIDEL"));
        productoCombo.M3DET.push(this.LoadM3PDetalle("0", "TOTALIMPUNIT"));
        //** FIN VALORES UNITARIOS */

        productoCombo.M3DET.push(this.LoadM3PDetalle(dCantidad.toString(), "CANTIDAD"));
        productoCombo.M3DET.push(this.LoadM3PDetalle("0", "TOTALIMPUESTOS"));
        productoCombo.M3DET.push(this.LoadM3PDetalle("0", "FIDELIZACION"));
        productoCombo.M3DET.push(this.LoadM3PDetalle("0", "TOTALPROMO"));
        productoCombo.M3DET.push(this.LoadM3PDetalle(valor, "CTBLDIMPPRD"));
        productoCombo.M3DET.push(this.LoadM3PDetalle((+valor * dCantidad).toString(), "PRECIOTOTALSINDTO"));
        productoCombo.M3DET.push(this.LoadM3PDetalle((+valor * dCantidad).toString(), "SUBTOTAL"));
        productoCombo.M3DET.push(this.LoadM3PDetalle((+valor * dCantidad).toString(), "PRECIOTOTALBASE"));
        productoCombo.M3DET.push(this.LoadM3PDetalle((+valor * dCantidad).toString(), "PRECIOTOTAL"));

        oM3Procesos.M3ENC.push(productoCombo);
        productosHijosDelCombo.forEach(producto => {
            producto.ID = +this.GetMaxAtributoFromLista(oM3Procesos.M3ENC, "ID") + 1; //JAGM, cambio de ID, caso cuando se agrega prd:1, prd:2 y de nuevo prd:1. En este caso en lÃ³gica anterior, se hace remove de item. y los ID quedaban repetidos.
            producto.IdEncPadre = productoCombo.ID;
            oM3Procesos.M3ENC.push(producto);
        });

        this.recalcularM3Proceso(oM3Procesos);
        return productoCombo;
    }

    recalcularM3Proceso(oM3Procesos: M3Procesos) {
        let productosAplSumaValor = oM3Procesos.M3ENC.filter(oM3ENC => {
            let detCantidad = oM3ENC.M3DET.find(x => x.NombreConcepto == "CANTIDAD");
            let detEsPrdCombo = oM3ENC.M3DET.find(x => x.NombreConcepto == "ESPRODPROMOCOMBO");
            return detCantidad && +detCantidad.Valor > 0 && !(detEsPrdCombo && detEsPrdCombo.Valor == "true")
        });

        oM3Procesos.ValorNeto = 0;
        oM3Procesos.Valor = 0;

        //for (const oM3ENC of this.oM3Procesos.M3ENC.filter(enc => !enc.IdEncPadre || enc.IdEncPadre <= 0)) {
        for (const oM3ENC of productosAplSumaValor) {
            oM3Procesos.ValorNeto += +oM3ENC.M3DET.find(x => x.NombreConcepto == "PRECIOTOTAL").Valor;
            oM3Procesos.Valor += +oM3ENC.M3DET.find(x => x.NombreConcepto == "SUBTOTAL").Valor;
        }
    }

    //Cargar M3Proceso encabezado items, desde producto general
    public LoadM3PEncItemsFromPrdGrlItem(oM3Procesos: M3Procesos, prodGRPSelected: TypeM3PrdGrp,
        oencabezadoItems: Array<M3PEncItems>, oM3PItemsWEB: M3PItemsWEB,
        oM3Ubicacion: M3Ubicacion, oM3ENCPROMO: Array<M3ENCPROMO>, oDataUser: any, oPadreM3PEncItems: M3PEncItems = undefined, valorDescuento = 0): M3PEncItems {

        var oM3PEncItems = new M3PEncItems();
        var oM3PrdGeneral: M3PrdGeneral;
        var dPRECIOUnitBase = 0;
        var infNivelesPrcio;
        var oPromocionProcesada: PromocionProcesada;
        var dTotalImpuestosTotal: number = 0;
        var dUnitarioMonedero: number = 0;
        var dUnitarioPromo: number = 0;

        //Verificar el precio a usar, usando la logica de niveles de precios.
        infNivelesPrcio = this.VerificarPrecioByNiveles(prodGRPSelected, oM3PItemsWEB.dCantidad);
        if (valorDescuento > 0) {
            oPromocionProcesada = new PromocionProcesada();
            oPromocionProcesada.PrecioTotalPromocion = prodGRPSelected.LoM3PrdGeneral[0].LoM3PrdLista.PRECIO * valorDescuento / 100;
            oPromocionProcesada.PrecioTotal = prodGRPSelected.LoM3PrdGeneral[0].LoM3PrdLista.PRECIO - oPromocionProcesada.PrecioTotalPromocion;
            oPromocionProcesada.ListPromocionesAsociadas = [];
        }
        else {
            oPromocionProcesada = this.CalcularPromociones(oM3Procesos, prodGRPSelected, oM3Ubicacion, oM3ENCPROMO, oDataUser, oM3PItemsWEB);
        }

        //Valida si el producto estÃ¡ restingido
        if (!this.validarProductoRestringido(oPromocionProcesada)) {
            this.AsignarPromocionesCombinadas(oM3Procesos, oPromocionProcesada, oM3PEncItems);

            //Calculo del total de puntos y el valor total de la promociÃ³n por la cqantidad de productos de la misma referencia
            dUnitarioMonedero = oPromocionProcesada.ValorTotalMonedero; //Unitario Monedero
            oPromocionProcesada.ValorTotalMonedero = +bigDecimal.multiply(oPromocionProcesada.ValorTotalMonedero, oM3PItemsWEB.dCantidad); //No se utiliza, se deja para usos adelante

            dUnitarioPromo = oPromocionProcesada.PrecioTotalPromocion; //Promocion unitario
            oPromocionProcesada.PrecioTotalPromocion = +bigDecimal.multiply(oPromocionProcesada.PrecioTotalPromocion, oM3PItemsWEB.dCantidad); //No se utiliza, se deja para usos adelante
            oM3PEncItems.M3DetCupones = this.get_list_cupones_from_promo(oPromocionProcesada, +oM3PItemsWEB.dCantidad);

            //Calculo de precio total, despues de promociones
            oM3PItemsWEB.dPrecioTotal = +bigDecimal.multiply(oPromocionProcesada.PrecioTotal, oM3PItemsWEB.dCantidad);

            //Cargar producto 
            oM3PrdGeneral = prodGRPSelected.LoM3PrdGeneral[0];

            oM3PEncItems.IdProducto = oM3PrdGeneral.SKU;
            oM3PEncItems.Lote = oM3PrdGeneral.LOTE;
            oM3PEncItems.ID = +this.GetMaxAtributoFromLista(oencabezadoItems, "ID") + 1; //JAGM, cambio de ID, caso cuando se agrega prd:1, prd:2 y de nuevo prd:1. En este caso en lÃ³gica anterior, se hace remove de item. y los ID quedaban repetidos.
            oM3PEncItems.Orden = +this.GetMaxAtributoFromLista(oencabezadoItems, "Orden") + 1;
            oM3PEncItems.Nombre = oM3PrdGeneral.NOMBRE1;
            oM3PEncItems.DISPONIBLE = oM3PrdGeneral.DISPONIBLE;
            oM3PEncItems.PathImage = oM3PItemsWEB.PathImagen;
            oM3PEncItems.CodigoBarras = oM3PItemsWEB.CodigoBarras;
            let pTotalBase = this.CalculatePrecioBase(oM3PrdGeneral.CTBLDIMPPRD, this.oMathTF.round(bigDecimal.multiply(oPromocionProcesada.PrecioTotal, oM3PItemsWEB.dCantidad), 2));
            if (oM3PItemsWEB.dCantidad != 0) {
                dPRECIOUnitBase = pTotalBase / oM3PItemsWEB.dCantidad;
            } else {
                dPRECIOUnitBase = 0;
            }

            dTotalImpuestosTotal = this.LoadM3PImpuestosFromPrdGrl(oM3PrdGeneral.CTBLDIMPPRD, oM3PEncItems, pTotalBase, oM3PItemsWEB.dCantidad, oPromocionProcesada.PrecioTotal);

            /** INICIO INFORMACION GENERAL */
            oM3PEncItems.M3DET.push(this.LoadM3PDetalle(moment(new Date()).format('YYYY-MM-DDTHH:mm:ss'), "FECHAIN"));                                  //------ Nunca Cambia
            oM3PEncItems.M3DET.push(this.LoadM3PDetalle(oM3PrdGeneral.CTBLDPRD, "CTBLDPRD"));                                  //------ Nunca Cambia
            oM3PEncItems.M3DET.push(this.LoadM3PDetalle(oM3PItemsWEB.BisObsequio.toString(), "ESOBSEQUIO"));
            oM3PEncItems.M3DET.push(this.LoadM3PDetalle(oM3PrdGeneral.SKP1, "PRD_ESTILO"));
            oM3PEncItems.M3DET.push(this.LoadM3PDetalle(oM3PrdGeneral.CTBLDIMPPRD, "CTBLDIMPPRD"));
            oM3PEncItems.M3DET.push(this.LoadM3PDetalle(oM3PItemsWEB.observacion.toString(), "OBSERVACION"));                  //------ Nunca Cambia
            if (oM3PItemsWEB.PathImagen) {
                oM3PEncItems.M3DET.push(this.LoadM3PDetalle(oM3PItemsWEB.PathImagen, "PATHIMAGEN"));
            }
            oM3PEncItems.M3DET.push(this.LoadM3PDetalle(oM3PItemsWEB.BisProductoPromo.toString(), "ESPRODPROMO")); // TRUE-> SI ES UN PRODUCTO POR PROMOCION, FALSE-> DE OTRO MODO
            //Detalles de factura electronica
            oM3PEncItems.M3DET.push(this.LoadM3PDetalle(prodGRPSelected.TIPO, "TIPO_PRD"));
            oM3PEncItems.M3DET.push(this.LoadM3PDetalle(oM3PItemsWEB.Unidad, "UNIDAD"));
            oM3PEncItems.M3DET.push(this.LoadM3PDetalle(oM3PItemsWEB.ClavePrdSRV, "CLAVEPRODSERV"));
            oM3PEncItems.M3DET.push(this.LoadM3PDetalle(oM3PItemsWEB.ClavePrdUnidad, "CLAVEUNIDAD"));
            this.AddItemsInterfaz(oM3PEncItems, prodGRPSelected.LoM3PrdAdicionales);
            this.AdicionalesToDetalles(oM3PEncItems, prodGRPSelected.LoM3PrdAdicionales)
            this.camposAdicionalesToDetalles(oM3PEncItems, oM3PItemsWEB)
            this.LoadDetalleNivelesPrecio(infNivelesPrcio, oM3PEncItems);
            this.AddInfoPromocionesADetalle(oPromocionProcesada, oM3PEncItems, oM3PItemsWEB.dCantidad); // Lista de Promociones 
            /**FIN INFORMACION GENERAL */

            //** INICIO VALORES UNITARIOS */
            oM3PEncItems.M3DET.push(this.LoadM3PDetalle(dPRECIOUnitBase.toString(), "PRECIOUNITBASE")); //Precio Sin impuestos
            oM3PEncItems.M3DET.push(this.LoadM3PDetalle(dTotalImpuestosTotal.toString(), "TOTALIMPUESTOS"));
            oM3PEncItems.M3DET.push(this.LoadM3PDetalle((this.oMathTF.round(this.GetUnitarioByTotal(oM3PItemsWEB.dCantidad, oM3PEncItems, "TOTALIMPUESTOS"), 2)).toString(), "TOTALIMPUNIT"));
            //oM3PEncItems.M3DET.push(this.LoadM3PDetalle((+oM3PrdGeneral.LoM3PrdLista.PRECIO - +dTotalImpuestosUnitario).toString(), "PUNITSINIMPUESTO"));//Sin descuento incluido Y sin Impuestos //------ Nunca Cambia
            oM3PEncItems.M3DET.push(this.LoadM3PDetalle((+dPRECIOUnitBase + dUnitarioPromo).toString(), "PUNITSINIMPUESTO"));//Sin descuento incluido Y sin Impuestos //------ Nunca Cambia //FS 20190725 Correccion en la fomra de calcularlo
            oM3PEncItems.M3DET.push(this.LoadM3PDetalle(oM3PrdGeneral.LoM3PrdLista.PRECIO.toString(), "PUNIT"));//Sin descuento incluido  ------ Nunca Cambia
            oM3PEncItems.M3DET.push(this.LoadM3PDetalle(oPromocionProcesada.PrecioTotal.toString(), "PUNITNETO"));//Con descuento incluido------ Nunca Cambia
            oM3PEncItems.M3DET.push(this.LoadM3PDetalle(dUnitarioMonedero.toString(), "UNITFIDEL"));//Unitario fidelizacion ------ Nunca Cambia
            oM3PEncItems.M3DET.push(this.LoadM3PDetalle(dUnitarioPromo.toString(), "VUNITPROMO"));//Unitario Promocion ------ Nunca Cambia

            //** FIN VALORES UNITARIOS */

            // *** Informacion de acciones en el cliente ***
            if (prodGRPSelected.encontradoLocal) {
                oM3PEncItems.M3DET.push(this.LoadM3PDetalle("LOCAL", "CONSULTOEN"));//Unitario Promocion ------ Nunca Cambia
            } else {
                oM3PEncItems.M3DET.push(this.LoadM3PDetalle("SERVIDOR", "CONSULTOEN"));//Unitario Promocion ------ Nunca Cambia
            }


            this.ValoresCalculadosProceso(oM3PEncItems, oM3PItemsWEB.dCantidad);

            //if (!oPadreM3PEncItems) {
            oM3Procesos.Valor = (+oM3Procesos.Valor) + (+oM3PEncItems.M3DET.find(det => det.NombreConcepto == "SUBTOTAL").Valor) // (+oM3PItemsWEB.dPrecioTotal);
            oM3Procesos.ValorNeto = (+oM3Procesos.ValorNeto) + (+oM3PEncItems.M3DET.find(det => det.NombreConcepto == "PRECIOTOTAL").Valor);
            //}

            //Verificar obsequios del producto que se ingreso al carrito de compras
            this.VerificarObsequios(oPromocionProcesada, oM3PItemsWEB.dCantidad, oM3PEncItems);
        }
        else {
            oM3PEncItems["MensajeError"] = "Producto Restringido";
        }

        return oM3PEncItems;
    }

    /**
     * Retorna true si este producto se encuentra restringido
     * @param oPromocionProcesada 
     */
    public validarProductoRestringido(oPromocionProcesada: PromocionProcesada): boolean {
        if (oPromocionProcesada.ListPromocionesAsociadas) {
            let promoRestringido = oPromocionProcesada.ListPromocionesAsociadas.find(x => x.Tipo == "RESTRICCION");
            if (promoRestringido) {
                return true;
            }
        }
        return false;
    }

    /**
     * Retorna el mÃ¡ximo valor de un atributo dentro de la lista cualquiera 
     */
    public GetMaxAtributoFromLista(lista, atributo) {
        if (lista.length > 0) {
            let listID = lista.map(x => x[atributo]);
            return Math.max.apply(Math, listID);
        } else {
            return 0;
        }
    }


    /**
     * Valores Calculados por proceso.
     * @param oM3PEncItems 
     * @param dCantidad 
     */
    public ValoresCalculadosProceso(oM3PEncItems: M3PEncItems, dCantidad: number) {
        /** INICIO VALORES DINAMICOS */
        // var dTotalImpuestos = (+this.GetTotalByUnitario(dCantidad, oM3PEncItems, "TOTALIMPUNIT"));
        // var dPrecioTotalSinDto = this.GetTotalByUnitario(dCantidad, oM3PEncItems, "PUNIT")
        // var dSubTotal = Math.round((+dPrecioTotalSinDto - +dTotalImpuestos) * 100) / 100;

        let subTotal = 0;
        let precioTotalSinDto = 0;
        let totalImpuestos
        //Agregar Impuestos
        totalImpuestos = this.agregarImpuesto(oM3PEncItems, dCantidad);

        //FS 20190725 Arreglo en el calculo de totales en caso de haber impuestos
        if (oM3PEncItems.M3PImpuestos.length > 0) {
            //Subtotal Sumas de las bases
            subTotal = this.oMathTF.round(((this.oMathTF.round(+this.GetTotalByUnitario(dCantidad, oM3PEncItems, "PRECIOUNITBASE"), 2)) + (+this.GetTotalByUnitario(dCantidad, oM3PEncItems, "VUNITPROMO"))), 2);
            totalImpuestos = this.getValorTotalFromImpuestos(oM3PEncItems, "Valor");
            precioTotalSinDto = subTotal + totalImpuestos;
        }
        else {
            //Se asume que no hay impuestos entonces el subTotal es igual al precioTotalSinDto
            precioTotalSinDto = this.oMathTF.round(this.GetTotalByUnitario(dCantidad, oM3PEncItems, "PUNIT"), 2);
            subTotal = precioTotalSinDto;
        }

        this.InsUpdDetItem(oM3PEncItems, dCantidad.toString(), "CANTIDAD");
        this.InsUpdDetItem(oM3PEncItems, (this.oMathTF.round(totalImpuestos, 2)).toString(), "TOTALIMPUESTOS");
        this.InsUpdDetItem(oM3PEncItems, (this.oMathTF.round(+this.GetUnitarioByTotal(dCantidad, oM3PEncItems, "TOTALIMPUESTOS"), 2)).toString(), "TOTALIMPUNIT");

        //La fidelizacion es un porcantaje por ende no debe multiplicarse this.InsUpdDetItem(oM3PEncItems, this.GetTotalByUnitario(dCantidad, oM3PEncItems, "UNITFIDEL").toString(), "FIDELIZACION");
        this.InsUpdDetItem(oM3PEncItems, oM3PEncItems.M3DET.find(det => det.NombreConcepto == "UNITFIDEL").Valor, "FIDELIZACION");
        //this.InsUpdDetItem(oM3PEncItems, (this.oMathTF.round(+this.GetTotalByUnitario(dCantidad, oM3PEncItems, "PUNITNETO"), 2)).toString(), "PRECIOTOTAL");
        //this.InsUpdDetItem(oM3PEncItems, (+this.GetTotalByUnitario(dCantidad, oM3PEncItems, "PUNITNETO")).toString(), "PRECIOTOTALREAL");
        this.InsUpdDetItem(oM3PEncItems, precioTotalSinDto.toString(), "PRECIOTOTALSINDTO");
        this.InsUpdDetItem(oM3PEncItems, subTotal.toString(), "SUBTOTAL");
        this.InsUpdDetItem(oM3PEncItems, moment(new Date()).format('YYYY-MM-DD'), "FUT");
        this.InsUpdDetItem(oM3PEncItems, (this.oMathTF.round(+this.GetTotalByUnitario(dCantidad, oM3PEncItems, "VUNITPROMO"), 2)).toString(), "TOTALPROMO");
        this.InsUpdDetItem(oM3PEncItems, (this.oMathTF.round(+this.GetTotalByUnitario(dCantidad, oM3PEncItems, "PRECIOUNITBASE"), 2)).toString(), "PRECIOTOTALBASE"); //Precio Sin impuestos        
        this.InsUpdDetItem(oM3PEncItems, (this.oMathTF.round((subTotal + +oM3PEncItems.M3DET.find(det => det.NombreConcepto == "TOTALIMPUESTOS").Valor - +oM3PEncItems.M3DET.find(det => det.NombreConcepto == "TOTALPROMO").Valor), 2)).toString(), "PRECIOTOTAL");

        /** FIN VALORES DINAMICOS */
    }

    /**
     * Retorna la sumatoria de los valores de un atributo dado del arreglo de impuestos
     * @param oM3PEncItems 
     * @param atributo 
     */
    public getValorTotalFromImpuestos(oM3PEncItems: M3PEncItems, atributo: string): number {
        let sumatoria = 0;
        for (let _i = 0; _i < oM3PEncItems.M3PImpuestos.length; _i++) {
            const impuesto = oM3PEncItems.M3PImpuestos[_i];
            sumatoria = sumatoria + (+impuesto[atributo]);
        }
        return sumatoria;
    }

    private agregarImpuesto(oM3PEncItems: M3PEncItems, cantidad: number) {
        let det_ctbld_imp_prd = oM3PEncItems.M3DET.find(det => det.NombreConcepto == "CTBLDIMPPRD");
        let det_precio_unit_base = oM3PEncItems.M3DET.find(det => det.NombreConcepto == "PRECIOUNITBASE");
        let valorTotalImpuestos: number = 0;
        if (det_ctbld_imp_prd && det_precio_unit_base) {
            valorTotalImpuestos = this.LoadM3PImpuestosFromPrdGrl(det_ctbld_imp_prd.Valor, oM3PEncItems, +bigDecimal.multiply(det_precio_unit_base.Valor, cantidad), cantidad, +oM3PEncItems.M3DET.find(det => det.NombreConcepto == "PUNITNETO").Valor);
        }
        return valorTotalImpuestos;
    }

    private InsUpdDetItem(oM3PEncItems: M3PEncItems, valor: string, sConcepto: string) {
        var oDet: M3PDetalleItems;
        oDet = oM3PEncItems.M3DET.find(det => det.NombreConcepto == sConcepto);
        if (oDet) {
            // Existe Actualiza
            oDet.Valor = valor;
        } else {
            //No existe agrega
            oM3PEncItems.M3DET.push(this.LoadM3PDetalle(valor.toString(), sConcepto));
        }
    }

    /**
     * Obtener valor total
     * @param cantidad Nueva Cantidad 
     * @param oM3PEncItems 
     * @param DescUnitario 
     */
    private GetTotalByUnitario(cantidad: number, oM3PEncItems: M3PEncItems, DescUnitario: string) {
        try {
            var unitario = oM3PEncItems.M3DET.find(det => det.NombreConcepto == DescUnitario).Valor;
            return +bigDecimal.multiply(unitario, cantidad);
        } catch {
            return 0;
        }
    }

    /**
     * Obtener valor unitario
     * @param cantidad 
     * @param oM3PEncItems 
     * @param DescTotal 
     */
    private GetUnitarioByTotal(cantidad: number, oM3PEncItems: M3PEncItems, DescTotal: string) {
        try {
            if (+cantidad == 0) {
                return 0;
            }
            var total = oM3PEncItems.M3DET.find(det => det.NombreConcepto == DescTotal).Valor;
            return +total / +cantidad;
        } catch {
            return 0;
        }
    }

    /**
     * Adicionar detalles relacionados con la informacion de sw externo.
     * @param oM3PEncItems Objeto donde se guardarÃ¡ los nuevos atributos.
     * @param oAdicionales Desde donde se sacarÃ¡ la informaciÃ³n.
     */
    public AddItemsInterfaz(oM3PEncItems: M3PEncItems, oAdicionales: Array<M3PrdAdicionales>) {
        try {
            var oAdicionalesFilter: Array<M3PrdAdicionales>;
            oAdicionalesFilter = oAdicionales.filter(a => a.ATRIBUTO.startsWith("CSIA_"));
            for (var i = 0; i < oAdicionalesFilter.length; i++) {
                oM3PEncItems.M3DET.push(this.LoadM3PDetalle(oAdicionalesFilter[i].VALOR, oAdicionalesFilter[i].ATRIBUTO));
            }

        } catch {

        }

    }


    /**
     * Adicionar detalles 
     * @param oM3PEncItems Objeto donde se guardarÃ¡ los nuevos atributos.
     * @param oAdicionales Desde donde se sacarÃ¡ la informaciÃ³n.
     */
    public AdicionalesToDetalles(oM3PEncItems: M3PEncItems, oAdicionales: Array<M3PrdAdicionales>) {
        try {
            for (var i = 0; i < oAdicionales.length; i++) {
                oM3PEncItems.M3DET.push(this.LoadM3PDetalle(oAdicionales[i].VALOR, "ADC_" + oAdicionales[i].ATRIBUTO));
            }
        } catch {

        }

    }

    public camposAdicionalesToDetalles(oM3PEncItems: M3PEncItems, oM3PItemsWEB: M3PItemsWEB) {
        try {
            for (var i = 0; i < oM3PItemsWEB.CamposAdicionales.length; i++) {
                oM3PEncItems.M3DET.push(this.LoadM3PDetalle(oM3PItemsWEB.CamposAdicionales[i].VALOR, "CAMADC_" + oM3PItemsWEB.CamposAdicionales[i].ATRIBUTO));
            }
        } catch {

        }
    }




    /**
     * Agregar informacion de promociones Nombre, ID. a detalle del encabezado de producto agregado
     * @param oPromocionProcesada Informacion de promociones procesadas
     * @param oM3PEncItems Encabezado de items
     */
    public GenerarInfoPromocionesProcesadas(oPromocionProcesada: PromocionProcesada, iCantidad: number, aplicadas = true) {
        var sNombres: string = "";
        var sIds: string = "";
        var sValores: string = "";
        var data;
        if (oPromocionProcesada && oPromocionProcesada.ListPromocionesAsociadas && oPromocionProcesada.ListPromocionesAsociadas.length > 0) {
            if (aplicadas) {
                oPromocionProcesada.ListPromocionesAsociadas.filter(x => x.Aplicada).filter(x => x.PromocionCombinada == null).forEach(promo => {
                    sNombres = sNombres + promo.Nombre + ",";
                    sIds = sIds + promo.IDPromocion + ",";
                    sValores = sValores + bigDecimal.multiply(promo.Valor, iCantidad) + ",";
                });
            }
            else {
                oPromocionProcesada.ListPromocionesAsociadas.filter(x => !x.Aplicada).filter(x => x.PromocionCombinada == null).forEach(promo => {
                    sNombres = sNombres + promo.Nombre + ",";
                    sIds = sIds + promo.IDPromocion + ",";
                    sValores = sValores + bigDecimal.multiply(promo.Valor, iCantidad) + ",";
                });
            }
            data = { "NOMBRES": sNombres, "ID": sIds, "VALORES": sValores }
            return data;
        }
        return null;
    }



    /**
     * Adicionar detalle de promociones
     * @param oM3PEncItems 
     * @param sNombres 
     * @param sIds 
     */
    public AddInfoPromocionesADetalle(oPromocionProcesada: PromocionProcesada, oM3PEncItems: M3PEncItems, iCantidad: number) {
        var data = this.GenerarInfoPromocionesProcesadas(oPromocionProcesada, iCantidad)
        if (data) {
            oM3PEncItems.M3DET.push(this.LoadM3PDetalle(data.NOMBRES, "NOMB_PROMOC"));
            oM3PEncItems.M3DET.push(this.LoadM3PDetalle(data.ID, "ID_PROMOC"));
            oM3PEncItems.M3DET.push(this.LoadM3PDetalle(data.VALORES, "VAL_PROMOC"));

            //Ahora se agrega una dinamica por atributo de la promo para facilitar la retoma de esta informaciÃ³n
            let listNombre = data.NOMBRES.replace(/.$/, "").split(",");
            let listId = data.ID.replace(/.$/, "").split(",");
            let listValor = data.VALORES.replace(/.$/, "").split(",");

            for (let _i = 0; _i < listId.length; _i++) {
                oM3PEncItems.M3DET.push(this.LoadM3PDetalle(listNombre[_i], "NOMB_PROMOC_" + _i));
                oM3PEncItems.M3DET.push(this.LoadM3PDetalle(listId[_i], "ID_PROMOC_" + _i));
                oM3PEncItems.M3DET.push(this.LoadM3PDetalle(listValor[_i], "VAL_PROMOC_" + _i));
            }
        }

        data = this.GenerarInfoPromocionesProcesadas(oPromocionProcesada, iCantidad, false)
        if (data) {
            oM3PEncItems.M3DET.push(this.LoadM3PDetalle(data.NOMBRES, "NOMB_PROMOC_NOPRO"));
            oM3PEncItems.M3DET.push(this.LoadM3PDetalle(data.ID, "ID_PROMOC_NOPRO"));
            oM3PEncItems.M3DET.push(this.LoadM3PDetalle(data.VALORES, "VAL_PROMOC_NOPRO"));
        }

    }

    /**
     * Cargar a detalle informacion de niveles de precio
     * @param infNivelesPrcio Informacion de niveles de precio
     * @param oM3PEncItems Objeto donde se cargarÃ¡ la informacion
     */
    public LoadDetalleNivelesPrecio(infNivelesPrcio, oM3PEncItems: M3PEncItems) {
        if (infNivelesPrcio && infNivelesPrcio.NIVEL !== undefined) {
            oM3PEncItems.M3DET.push(this.LoadM3PDetalle(infNivelesPrcio.NIVEL, "NIVELPRECIO"));
        }
    }

    /**
     * Verificar con que nivel de precio va a trabajar
     * @param prodGRPSelected El producto ingresado
     * @param iCantidad La cantidad de productos que va a ingresar
     */
    public VerificarPrecioByNiveles(prodGRPSelected: TypeM3PrdGrp, iCantidad: number) {
        try {
            var oM3Presentaciones: M3Presentaciones;
            var jRespNiveles = {};
            if (prodGRPSelected.LoM3PrdGeneral[0].LoM3PrdLista.M3Presentaciones &&
                prodGRPSelected.LoM3PrdGeneral[0].LoM3PrdLista.M3Presentaciones.length > 0) {

                oM3Presentaciones = prodGRPSelected.LoM3PrdGeneral[0].LoM3PrdLista.M3Presentaciones.find(x => iCantidad >= x.TOPE);
                if (oM3Presentaciones) {
                    prodGRPSelected.LoM3PrdGeneral[0].LoM3PrdLista.PRECIO = oM3Presentaciones.VALOR;
                    jRespNiveles = { "PRECIO": oM3Presentaciones.VALOR, "NIVEL": oM3Presentaciones.NIVELPRS };
                }
            }
            return jRespNiveles;
        } catch {
            return null;
        }
    }

    public VerificarPrecioByNivelesGeneral(oM3PrdGeneral: M3PrdGeneral, iCantidad: number) {
        try {
            var oM3Presentaciones: M3Presentaciones;
            var jRespNiveles = {};
            if (oM3PrdGeneral.LoM3PrdLista.M3Presentaciones && oM3PrdGeneral.LoM3PrdLista.M3Presentaciones.length > 0) {

                oM3Presentaciones = oM3PrdGeneral.LoM3PrdLista.M3Presentaciones.find(x => iCantidad >= x.TOPE);
                if (oM3Presentaciones) {
                    oM3PrdGeneral.LoM3PrdLista.PRECIO = oM3Presentaciones.VALOR;
                    jRespNiveles = { "PRECIO": oM3Presentaciones.VALOR, "NIVEL": oM3Presentaciones.NIVELPRS };
                }
            }
            return jRespNiveles;
        } catch {
            return null;
        }
    }

    /**
     * Retorna los cupones generados de la lista de promoprocesadas
     * @param oPromocionProcesada 
     */
    public get_list_cupones_from_promo(oPromocionProcesada: PromocionProcesada, cantidad: number): Array<M3PDetalleCupon> {
        var list_cupones = Array<M3PDetalleCupon>();

        if (oPromocionProcesada.ListPromocionesAsociadas) {
            for (let _i = 0; _i < oPromocionProcesada.ListPromocionesAsociadas.length; _i++) {
                var promo_asociada = oPromocionProcesada.ListPromocionesAsociadas[_i];

                if (promo_asociada.IdCupon) {
                    let cupon = new M3PDetalleCupon();
                    cupon.IdCupon = promo_asociada.IdCupon;
                    cupon.Cantidad = cantidad;
                    list_cupones.push(cupon);
                }
            }
        }

        return list_cupones;
    }

    //Asignar a promociones combianas desde lo que se encontrÃ³ al encabezado item, del producto seleccionado
    public AsignarPromocionesCombinadas(oM3Procesos: M3Procesos, oPromocionProcesada: PromocionProcesada, oM3PEncItems: M3PEncItems) {
        if (oPromocionProcesada != null && oPromocionProcesada.ListPromocionesAsociadas != null) {
            oPromocionProcesada.ListPromocionesAsociadas.forEach(promoAso => {
                if (promoAso.PromocionCombinada != null) {
                    //Se agrega promocion combinada a encabezado de items.
                    oM3PEncItems.PromoCombinadas.push(promoAso.PromocionCombinada);
                    ///Agregar promociones combinadas
                    var oM3PDetalleItems: M3PDetalleItems;
                    oM3PDetalleItems = oM3PEncItems.M3DET.find(x => x.NombreConcepto == "PROMOCOMBI")
                    if (oM3PDetalleItems) {
                        oM3PDetalleItems.Valor = JSON.stringify(oM3PEncItems.PromoCombinadas);
                    }
                    else {
                        oM3PEncItems.M3DET.push(this.LoadM3PDetalle(JSON.stringify(oM3PEncItems.PromoCombinadas), "PROMOCOMBI"));
                    }
                    this.AsignarPromocionesCombinadasAM3Proceso(oM3Procesos, promoAso.PromocionCombinada);
                }
            });
        }
    }

    /**
     * Asignar promociones combiandas a M3 Proceso, este, valida que no exista un promocion anterior.
     */
    public AsignarPromocionesCombinadasAM3Proceso(oM3Procesos: M3Procesos, oPromocionCombinada: PromocionCombinada) {
        if (!oM3Procesos.PromosCombinadas) {
            oM3Procesos.PromosCombinadas = new Array<PromocionCombinada>();
        }
        if (oM3Procesos.PromosCombinadas.find(x => x.IdPromocionCombinada == oPromocionCombinada.IdPromocionCombinada)) {
            /////// existe
        } else {
            ////// No Existe
            oM3Procesos.PromosCombinadas.push(oPromocionCombinada);
        }
        if (oM3Procesos.PromosCombinadas) {
            this.AddDinamicaProcesoCombinadas(oM3Procesos);
        }

    }

    /**
     * Adicionar a dinamicas proceso de combinadas
     * @param ioM3Proceso 
     */
    public AddDinamicaProcesoCombinadas(ioM3Proceso: M3Procesos) {
        var oM3PDinamicasFinded: M3PDinamicas;
        oM3PDinamicasFinded = ioM3Proceso.lM3PDinamicas.find(x => x.Nombre == "COMBINADA");
        if (oM3PDinamicasFinded) {
            var arrPromo: Array<PromocionCombinada> = JSON.parse(oM3PDinamicasFinded.Valor);
            for (var i = 0; i < arrPromo.length; i++) {
                var oPromoCombi: PromocionCombinada = ioM3Proceso.PromosCombinadas.find(x => x.IdPromocionCombinada == arrPromo[i].IdPromocionCombinada);
                if (!oPromoCombi) {
                    ioM3Proceso.PromosCombinadas.push(arrPromo[i]);
                }
            }
            oM3PDinamicasFinded.Valor = JSON.stringify(ioM3Proceso.PromosCombinadas);
        } else {
            var oM3PDinamicas = new M3PDinamicas();
            oM3PDinamicas.Nombre = "COMBINADA";
            oM3PDinamicas.Valor = JSON.stringify(ioM3Proceso.PromosCombinadas);

            ioM3Proceso.lM3PDinamicas.push(oM3PDinamicas);
        }

    }

    //Calculo de promociones
    public CalcularPromociones(oM3Procesos: M3Procesos, prodGRPSelected: TypeM3PrdGrp,
        oM3Ubicacion: M3Ubicacion, oM3ENCPROMO: Array<M3ENCPROMO>, oDataUser: any, oM3PItemsWEB: M3PItemsWEB): PromocionProcesada {
        var oPromocionProcesada = new PromocionProcesada();
        var lTipos = new Array<string>();
        lTipos.push("DIRECTA");
        lTipos.push("COMBINADA");
        lTipos.push("MONEDERO");
        lTipos.push("MANUAL");

        try {
            if (oM3ENCPROMO != null) {
                var arrPromo: Array<any>;
                var opromocionesService = new promocionesService(oDataUser, oM3PItemsWEB);

                arrPromo = opromocionesService.VerificarPromociones(oM3Procesos, prodGRPSelected, oM3Ubicacion, oM3ENCPROMO, lTipos);
                oPromocionProcesada = opromocionesService.ProcesarPromocion(arrPromo, prodGRPSelected, oM3ENCPROMO);

                return oPromocionProcesada;
            } else {
                throw new Error('No hay informacion de promociones');
            }

        } catch {
            oPromocionProcesada = new PromocionProcesada();
            oPromocionProcesada.PrecioTotal = prodGRPSelected.LoM3PrdGeneral[0].LoM3PrdLista.PRECIO;
            oPromocionProcesada.PrecioTotalPromocion = 0;
            oPromocionProcesada.ListPromocionesAsociadas = null;
            return oPromocionProcesada;
        }
    }


    //Verificar obsequios y agregarlos.
    public VerificarObsequios(oPromocionProcesada: PromocionProcesada, cantidad: number, oM3PEncItems: M3PEncItems) {
        try {
            var arrPromocionesAsociadas: Array<PromocionesAsociadas>;
            this.obsequiosCantidad = 0;
            if (oPromocionProcesada.ListPromocionesAsociadas != null) {
                arrPromocionesAsociadas = oPromocionProcesada.ListPromocionesAsociadas.filter(promo => promo.ListObsSKU != null);

                if (arrPromocionesAsociadas != null && arrPromocionesAsociadas.length > 0) {
                    arrPromocionesAsociadas.forEach(promo => {
                        this.obsequioOPromo == -1
                        if (!promo.ListObsSKU.length) promo.ListObsSKU = [promo.ListObsSKU];

                        if (this.validaSiTieneOtraPromo(promo, oPromocionProcesada.ListPromocionesAsociadas)) {
                            this.obsequioOPromo = promo.IDPromocion;
                        }
                        this.armarListaObsequiosSKU(promo, oM3PEncItems, cantidad);
                    });
                }
            }
        } catch (ex) {
            console.log(ex);
        }
    }

    armarListaObsequiosSKU(promo: PromocionesAsociadas, oM3PEncItems: M3PEncItems, cantidad: number) {
        if (promo.ReglaObseq == "EXC") {
            this.asignarIdEncPadreObsequio(promo, oM3PEncItems);
            this.obsequiosExc = true;
            this.obsequiosCantidad = cantidad;
        }
        else {
            this.asignarIdEncPadreObsequio(promo, oM3PEncItems);
            promo.ListObsSKU.forEach(element => {
                element.Cantidad = cantidad * +element.Cantidad;
            });
            this.obsequiosExc = false;
        }
        this.oListaObsequios = promo.ListObsSKU;
    }

    asignarIdEncPadreObsequio(promo: PromocionesAsociadas, oM3PEncItems: M3PEncItems) {
        if (promo.ListObsSKU.length > 0) {
            promo.ListObsSKU.forEach(element => {
                element.idEncPadre = oM3PEncItems.ID;
            });
        }
    }

    armarListaObsequiosCombiSKU(combi, oM3PEncItems: M3PEncItems, cantidad: number) {
        if (combi.Accion.ReglaObseq == "EXC") {
            this.asignarIdEncPadreObsequioCombinado(combi.Accion.OBSEQUIOS, oM3PEncItems);
            this.obsequiosExc = true;
            this.obsequiosCantidad = cantidad;
        }
        else {
            this.asignarIdEncPadreObsequioCombinado(combi.Accion.OBSEQUIOS, oM3PEncItems);
            combi.Accion.OBSEQUIOS.forEach(element => {
                element.Cantidad = cantidad * +element.Cantidad;
            });
            this.obsequiosExc = false;
        }
        this.oListaObsequios = combi.Accion.OBSEQUIOS;
    }

    asignarIdEncPadreObsequioCombinado(obsequios, oM3PEncItems: M3PEncItems) {
        if (obsequios.length > 0) {
            obsequios.forEach(element => {
                element.idEncPadre = oM3PEncItems.ID;
            });
        }
    }

    //Retorna true si hay otra promo aplicada donde ni la promo de obsequio o la aplicada son fijas y una de las dos es EXC
    validaSiTieneOtraPromo(promoObsequio: PromocionesAsociadas, arrPromocionesAsociadas: Array<PromocionesAsociadas>): boolean {
        if (promoObsequio.Regla != "ACM") {
            let oPromosNoObsequios = arrPromocionesAsociadas.filter(x => x.IDPromocion != promoObsequio.IDPromocion);
            for (const promo of oPromosNoObsequios) {
                if (promo.Regla != "ACM") {
                    if (promo.Aplicada && (promo.Regla == "EXC" || promoObsequio.Regla == "EXC")) {
                        return true;
                    }
                }
            }
        }

        return false;
    }


    //procesamiento de obsequios
    public async ProcesarObsequios(oDataUser: any,
        oM3PItemsWEB: M3PItemsWEB, oM3Ubicacion: M3Ubicacion, EnLinea: boolean, oM3Procesos: M3Procesos) {
        try {
            this.obsequiosExc = false;
            this.obsequioOPromo = -1;
            if (this.oListaObsequios != null && this.oListaObsequios.length > 0) {
                for (let i = 0; i < this.oListaObsequios.length; i++) {
                    if (this.oListaObsequios[i].SKU) {
                        //JAGM 20190810 valida, cuantos productos se agrega en el obsequio.
                        if (this.oListaObsequios[i].Cantidad) {
                            oM3PItemsWEB.dCantidad = this.oListaObsequios[i].Cantidad;
                        }
                        //JAGM 20191112 se agreg funcionalidad de obsequios
                        oM3PItemsWEB.BisObsequio = true;
                        oM3PItemsWEB.IDEncPadre = this.oListaObsequios[i].idEncPadre;
                        oM3PItemsWEB.TipoAgrupacion = "OBSQ";
                        await this.GuardarPromocion(this.oListaObsequios[i], oDataUser, oM3PItemsWEB, oM3Ubicacion, EnLinea, oM3Procesos);
                    }
                }
            }
        } catch (ex) {
            console.log(ex);
        }
        this.oListaObsequios = null;
    }


    //Guardar promocion segun un sku
    //1. Buscar el producto segun el sku
    //2. Agregar el producto a m3procesos
    //3. Agregar al carrito de compras.
    public async GuardarPromocion(promo, oDataUser: any,
        oM3PItemsWEB: M3PItemsWEB, oM3Ubicacion: M3Ubicacion, EnLinea: boolean, oM3Procesos: M3Procesos) {
        // 20181121  var sKeyCarrito;
        // 20181121 var oM3Procesos;
        var procesoPromo;
        //Obtener key de carrito de compras
        // 20181121 sKeyCarrito = oM3Data.GetKeyCarritoCompras(sIDKatios, oDataUser.UsuarioSistema.TDOC, oDataUser.UsuarioSistema.NDOC, oDataUser.UsuarioSistema.UBICACION, oDataUser.UsuarioSistema.IDHUB);


        // 20181121 oM3Procesos = await oM3Data.GetDataPouchBD(sKeyCarrito);
        procesoPromo = await this.AdicionarPromocionAProceso(promo, oM3Procesos, oM3PItemsWEB, oM3Ubicacion, EnLinea, oDataUser);
        //Guardar en pouch DB
        // 20181121  await oM3Data.AddToPouchBDCarritoCompras(sKeyCarrito, procesoPromo);
    }

    //Obtener los producto segun su SKU, sacando la informacion desde pouchDB.
    public async AdicionarPromocionAProceso(promo, oM3Procesos: M3Procesos, oM3PItemsWEB: M3PItemsWEB, oM3Ubicacion: M3Ubicacion, EnLinea: boolean, oDataUser: any) {
        var oProducto: TypeM3PrdGrp = null;
        oProducto = await this.GetProductoBySKU(promo.SKU, EnLinea, oM3Procesos, oDataUser);
        console.debug(oProducto);
        if (oProducto != null) {
            //Ya no se deja precio cero sino que como es obsequio simula un descuento del 100% 
            //Producto.LoM3PrdGeneral[0].LoM3PrdLista.PRECIO = 0;
            //Agregar a m3procesos el obsequio.
            //oM3Procesos = this.LoadM3ProcesoFromData(oM3Procesos, oProducto, oM3PItemsWEB, oM3Ubicacion, null, null);

            oM3Procesos = this.addtocart(oM3PItemsWEB, oProducto, null, null, oDataUser, this.gsIdkatios, oM3Ubicacion, null, oM3Procesos, null, 100);//*Se manda valor de descuennto 100 %
        }
        return oM3Procesos;
    }

    //Obtener producto segun el SKU
    public async GetProductoBySKU(sSKU, EnLinea: boolean, oM3Procesos: M3Procesos, oDataUser: any, disponibleM3Enc = null) {
        var oServiceM3Maestro = new ServiceM3Maestro();
        var productos;
        var oProducto: TypeM3PrdGrp = null;
        var oServiceLoadListaPrecio = new ServiceLoadListaPrecio(this.gsIdkatios);

        //oServiceListaPrecio.GenerateDataValidacion(oDataUser, oM3Procesos.TMIdProceso);
        if (!EnLinea && !oDataUser.UsuarioSistema.FechaPrecio) {
            var sIDProductos = this.gsIdkatios + "?PRD";
            productos = await this.oM3CouchMaestro.get(sIDProductos);
            oProducto = oServiceM3Maestro.GetM3PrdGrpFromList(productos.M3ListProductos.M3GRP, sSKU);
        } else {
            oProducto = await oServiceM3Maestro.M3GetProductoBySKUAsync(this.GoPostServiceM3, this.gsIdkatios, sSKU, oDataUser, oM3Procesos.Ubic1.toString());
        }
        if (oProducto.LoM3PrdGeneral[0].DISPONIBLE <= 0 && disponibleM3Enc) {
            oProducto.LoM3PrdGeneral[0].DISPONIBLE = disponibleM3Enc;
        }

        await oServiceLoadListaPrecio.AsignarListaPrecio(oProducto, oDataUser, this.GoPostServiceM3);
        //oServiceListaPrecio.ValidarListaPrecios(oProducto, this.GoPostServiceM3, this.gsIdkatios);
        return oProducto;
    }

    //Calcular precio sin impuestos. La forma es calcular todo el valor del impuesto. EJ: 120.09 / 1.16. Si el valor del impuesto es: 16%
    public CalculatePrecioBase(CTBLDIMPPRD: string, dValorNeto: number) {
        //var dValorImpuesto: number = 1;
        var dValorBase: number = dValorNeto;
        try {
            var oxmlToJsonTF = new xmlToJsonTF();
            var jImpuestos;
            if (CTBLDIMPPRD != "") {
                jImpuestos = oxmlToJsonTF.convertXmlToJson(CTBLDIMPPRD);
                jImpuestos.IMPUESTOS.IMPUESTO.forEach(imp => {
                    //JAGM  20190626 Cambio de calculo de base de los impuestos.
                    if (imp.$.Metodologia == "PORCENTAJE") {
                        dValorBase = (+dValorBase) / (1 + +imp.$.Valor);
                    }
                    else {
                        dValorBase = (+dValorBase) - (+imp.$.Valor);
                    }
                });
            }
            //console.log(oM3PEncItems.M3Impuestos);
        } catch {
            console.log("Catch")
        }

        //return ((+dValorNeto) / (+dValorImpuesto));
        return dValorBase;
    }

    //Cargar informaciÃ³n de impuestos, desde el producto general
    public LoadM3PImpuestosFromPrdGrl(CTBLDIMPPRD: string, oM3PEncItems: M3PEncItems,
        dValorNeto: number, cantidad: number, valorTotalProductoUnit: number) {
        try {
            var oxmlToJsonTF = new xmlToJsonTF();
            var oM3PImpuestos: M3PImpuestos;
            let valorBaseTotal = this.oMathTF.round(dValorNeto, 2);
            let valorNetoTotal = valorBaseTotal;
            let valorTotalProductoTotal = +bigDecimal.multiply(valorTotalProductoUnit, cantidad);
            var jImpuestos;
            var dTotalImpuesto: number = 0;
            if (CTBLDIMPPRD != "") {
                jImpuestos = oxmlToJsonTF.convertXmlToJson(CTBLDIMPPRD);

                //JAGM 20190626 Cambio en orden de los impuestos.
                for (var i = jImpuestos.IMPUESTOS.IMPUESTO.length - 1; i >= 0; i--) {
                    let valorRealImp = 0;
                    var imp = jImpuestos.IMPUESTOS.IMPUESTO[i];
                    oM3PImpuestos = new M3PImpuestos();
                    oM3PImpuestos.CodImpuesto = imp.$.CodImp;
                    oM3PImpuestos.Porcentaje = imp.$.Valor;
                    if (imp.$.Metodologia == "PORCENTAJE") {//PORCENTAJE
                        valorRealImp = +bigDecimal.multiply(imp.$.Valor, valorNetoTotal);
                        oM3PImpuestos.Valor = this.oMathTF.round(valorRealImp, 2);
                        if (oM3PImpuestos.Valor < valorRealImp) {
                            oM3PImpuestos.LimiteOpuesto = +Math.ceil(+bigDecimal.multiply(valorRealImp, 100)) / 100;
                        }
                        else {
                            oM3PImpuestos.LimiteOpuesto = +Math.floor(+bigDecimal.multiply(valorRealImp, 100)) / 100;
                        }
                    }
                    else {//FIJO
                        valorRealImp = +imp.$.Valor;
                        oM3PImpuestos.Valor = this.oMathTF.round(valorRealImp, 2);
                        // if (oM3PImpuestos.Valor < valorRealImp) {
                        //     oM3PImpuestos.LimiteOpuesto = +Math.ceil(+bigDecimal.multiply(valorRealImp, 100)) / 100;
                        // }
                        // else {
                        //     oM3PImpuestos.LimiteOpuesto = +Math.floor(+bigDecimal.multiply(valorRealImp, 100)) / 100;
                        // }
                    }


                    //JAGM 20180912 Nuevo concepto de base
                    oM3PImpuestos.Base = valorNetoTotal;
                    dTotalImpuesto = (+dTotalImpuesto) + (+oM3PImpuestos.Valor);

                    //JAGM 20180912 Suma de Valor Neto
                    valorNetoTotal = (+valorNetoTotal) + (+oM3PImpuestos.Valor);

                    ///Solo adicione a impuestos, cuando es total impuestos
                    var impExiste: M3PImpuestos;
                    impExiste = oM3PEncItems.M3PImpuestos.find(imp => imp.CodImpuesto == oM3PImpuestos.CodImpuesto);
                    if (impExiste) {
                        //Borra en item
                        oM3PEncItems.M3PImpuestos = oM3PEncItems.M3PImpuestos.filter(imp => imp.CodImpuesto != oM3PImpuestos.CodImpuesto);
                    }
                    oM3PEncItems.M3PImpuestos.push(oM3PImpuestos);
                }
                // jImpuestos.IMPUESTOS.IMPUESTO.forEach(imp => {

                // });
            }

            //JAGM 20190726 se agrega validacion, ya que estaba quedando la resta, con valores como: 0.00000000001 = 1.1564564564e845 EJ
            if (dTotalImpuesto != 0) {
                //Diferencia redondeada a dos decimales
                dTotalImpuesto = this.oMathTF.round(dTotalImpuesto, 2);
                let diferencia = this.oMathTF.round((valorTotalProductoTotal - valorBaseTotal - dTotalImpuesto), 2);
                if (diferencia != 0) {
                    this.ajustadorDeImpuestos(oM3PEncItems, diferencia);
                }

                // "TOTALIMPUESTOS"
                return this.oMathTF.round((valorTotalProductoTotal - valorBaseTotal), 2);
            } else {
                return 0;
            }

        } catch {
            console.log("Catch")
            return 0;
        }
    }

    /**
     * FS 20190725
     * Corrige el valor que tomo el impuesto despues de haberse redondeado
     * Si al recorrer todos los impuestos la diferencia no se zanja, NI MODOS el error estÃ¡ en otra parte
     * Se crea esta funciÃ³n para resolver los errores de timbrado de factura electrÃ³nica
     * @param oM3PEncItems 
     * @param diferencia Diferencia que se debe saldar para conseguir el valor total de impuestos requerido
     */
    ajustadorDeImpuestos(oM3PEncItems: M3PEncItems, diferencia: number) {
        for (let _i = 0; _i < oM3PEncItems.M3PImpuestos.length; _i++) {
            const impuesto = oM3PEncItems.M3PImpuestos[_i];

            //Si la diferencia es positiva quiere decir que la suma de los impuestos es menor a la real
            if (diferencia > 0) {
                //Si el impuesto se redondeo hacia abajo quiere decir que se pudo redondear hacia arriba
                //Entonces lo "redondea hacia arriba" y resta una centesima a la diferencia
                if (impuesto.Valor < impuesto.LimiteOpuesto) {
                    impuesto.Valor = impuesto.LimiteOpuesto;
                    impuesto.Base = this.oMathTF.round(impuesto.Valor / impuesto.Porcentaje, 2);
                    diferencia = diferencia - 0.01;
                }
                //Si Valor>ValorReal quiere decir que redondeo hacia arriba y no debe modificar ese valor
            }
            //Si la diferencia es negativa quiere decir que la suma de los impuestos es mayor a la real
            else {
                //Si el impuesto se redondeo hacia arriba quiere decir que se pudo redondear hacia abajo
                //Entonces lo "redondea hacia abajo" y suma una centesima a la diferencia
                if (impuesto.Valor > impuesto.LimiteOpuesto) {
                    impuesto.Valor = impuesto.LimiteOpuesto;
                    impuesto.Base = this.oMathTF.round(impuesto.Valor / impuesto.Porcentaje, 2);
                    diferencia = diferencia + 0.01;
                }
                //Si Valor<ValorReal quiere decir que redondeo hacia abajo y no debe modificar ese valor
            }

            //Si ya se saldo la diferencia rompe el ciclo dando por concluido el ajuste
            if (diferencia == 0) {
                break;
            }
        }
    }

    //Load por unidad detalle del m3proceso items.
    public LoadM3PDetalle(sValor: string, sConcepto: string): M3PDetalleItems {
        var oM3PDetalleItems = new M3PDetalleItems();
        oM3PDetalleItems.NombreConcepto = sConcepto;
        oM3PDetalleItems.Valor = sValor;
        return oM3PDetalleItems;
    }


    //Generar promocion combinada
    public async GenerarPromoCombinada(oM3Procesos: M3Procesos, oDataUser: any) {
        if (!oM3Procesos.lM3PDinamicas || (oM3Procesos.lM3PDinamicas && !oM3Procesos.lM3PDinamicas.find(x => x.Nombre == "PUENTE_DIARIO"))) {
            var opromocionesService = new promocionesService(oDataUser, null);
            oM3Procesos = opromocionesService.ProcesarCombinada(oM3Procesos);
            this.RecalcularPrecios(oM3Procesos);
        }
    }


    //Compare M3Procesos. (First: @Param: ilM3ProcesosSQL VS Second: Get From CouchDB/PouchDB)
    public async CompareM3Proceso(sIDKatios: string, oM3Data: M3Data, oDataUser: any, ilM3ProcesosSQL: M3Procesos) {
        var oResp;
        try {
            //Get data, from PouchDB/CouchDB
            var PropertyCompare = ["ValorNeto", "Valor"];
            var sKeyCarrito: string;
            var oM3ProcesosCOUCH: M3Procesos;
            var bResp: boolean = true;

            sKeyCarrito = oM3Data.GetKeyCarritoCompras(sIDKatios, oDataUser.UsuarioSistema.TDOC, oDataUser.UsuarioSistema.NDOC, oDataUser.UsuarioSistema.UBICACION, oDataUser.UsuarioSistema.IDHUB);
            //Get data, from PouchDB/CouchDB
            oM3ProcesosCOUCH = await oM3Data.GetDataPouchBD(sKeyCarrito);

            //Start Compare
            for (var i = 0; i < PropertyCompare.length; i++) {
                if (ilM3ProcesosSQL[PropertyCompare[i]] != oM3ProcesosCOUCH[PropertyCompare[i]]) {
                    bResp = false;
                    break;
                }
            }

            if (bResp) {
                //Compare: ID, IdProducto y CANTIDAD
                for (var j = 0; j < ilM3ProcesosSQL.M3ENC.length; j++) {
                    if (oM3ProcesosCOUCH.M3ENC[j].ID != ilM3ProcesosSQL.M3ENC[j].ID ||
                        oM3ProcesosCOUCH.M3ENC[j].IdProducto != ilM3ProcesosSQL.M3ENC[j].IdProducto ||
                        oM3ProcesosCOUCH.M3ENC[j].M3DET.find(x => x.NombreConcepto == "CANTIDAD").Valor != ilM3ProcesosSQL.M3ENC[j].M3DET.find(x => x.NombreConcepto == "CANTIDAD").Valor) {
                        bResp = false;
                        break;
                    }
                }
            }

            oResp = { "bResp": bResp, "M3Procesos": oM3ProcesosCOUCH };
            return oResp;
        } catch (ex) {
            console.log("Error CompareM3Proceso");
            console.log(ex);
            oResp = { "bResp": true, "M3Procesos": null };
            return oResp;
        }

    }


    //Adicionar comercial al proceso, lo adiciona al arreglo de dinamicos asociado al proceso.
    public AddComercialToM3Proceso(oM3Procesos: M3Procesos, TdocComercial: string, NdocComercial: string) {
        oM3Procesos.lM3PDinamicas.push(this.CreateTuplaDinamica("TCOMERCIAL", TdocComercial));
        oM3Procesos.lM3PDinamicas.push(this.CreateTuplaDinamica("NCOMERCIAL", NdocComercial));
    }

    //Creacion y retorno de tupla de dinamicos, atados a proceso m3.
    public CreateTuplaDinamica(nombre, valor) {
        var oM3PDinamicas = new M3PDinamicas();
        oM3PDinamicas.Nombre = nombre;
        oM3PDinamicas.Valor = valor;

        return oM3PDinamicas;
    }


    ///Actualiza la cantidad de 
    public setCantidadALLYUPDCouch(oM3Procesos: M3Procesos, oM3Data: M3Data,
        oDataUser: any, sIDKatios: string, funcionOK: Function, funcionError: Function, iCantidad) {

        if (iCantidad == 0 && oM3Procesos.IDDiario === undefined) {
            ///Aun no esta registrado el proceso como tal, se puede borrar de raiz
            oM3Procesos.M3ENC = new Array<M3PEncItems>();
            this.UpdateM3ProcesosWithData(oM3Procesos, oM3Data, oDataUser, sIDKatios, "WEB", funcionOK, funcionError);
        } else {
            if (iCantidad == 0) {

                this.DeleteM3Proceso(oM3Data, oDataUser, sIDKatios).then(x => {
                    this.GetCarritoComprasPouchDB(oM3Data, oDataUser, sIDKatios).then(res => {
                        oM3Procesos = new M3Procesos();
                        funcionOK(oM3Procesos);
                    });
                });
            } else {
                oM3Procesos.M3ENC.forEach(enc => {
                    enc.M3DET.find(det => det.NombreConcepto == "CANTIDAD").Valor = iCantidad;
                });
                this.UpdateM3ProcesosWithData(oM3Procesos, oM3Data, oDataUser, sIDKatios, "WEB", funcionOK, funcionError);
            }
        }
    }

    ///Se cantidad de un producto especifico
    public setCantidadYUPDCouch(oM3Procesos: M3Procesos, oM3Data: M3Data,
        oDataUser: any, sIDKatios: string, funcionOK: Function,
        funcionError: Function, idProducto, Lote, iCantidad, tipoUbicacion, IDEnc,
        m3Ubicacion: M3Ubicacion, oM3ENCPROMO: Array<M3ENCPROMO>, forzarBorrad: boolean = false) {

        if ((iCantidad == 0 && oM3Procesos.IDDiario === undefined && tipoUbicacion == "WEB") || forzarBorrad) {
            ///Aun no esta registrado el proceso como tal, se puede borrar de raiz
            oM3Procesos.M3ENC = oM3Procesos.M3ENC.filter(prod => !(prod.IdProducto == idProducto && prod.ID == IDEnc) && !(prod.IdEncPadre == IDEnc));

            let loM3PItemsWEB = new M3PItemsWEB();
            loM3PItemsWEB.dCantidad = 0;
            this.UpdateM3ProcesosWithData(oM3Procesos, oM3Data, oDataUser, sIDKatios, tipoUbicacion, funcionOK, funcionError, m3Ubicacion);
        } else {
            // JAGM 20191021, no hacer lÃ³gica de promociones y varios, cuÃ¡ndo se borra el item.
            if (iCantidad == 0) {
                oM3Procesos.M3ENC.find(enc => enc.IdProducto == idProducto && enc.Lote == Lote && enc.ID == IDEnc).M3DET.find(det => det.NombreConcepto == "CANTIDAD").Valor = iCantidad;
                this.UpdateM3ProcesosWithData(oM3Procesos, oM3Data, oDataUser, sIDKatios, tipoUbicacion, funcionOK, funcionError, m3Ubicacion);
            } else {
                this.setCantidadV2(oM3Procesos, idProducto, Lote, iCantidad, IDEnc, oDataUser, sIDKatios, m3Ubicacion, oM3ENCPROMO).then(resp => {
                    this.UpdateM3ProcesosWithData(oM3Procesos, oM3Data, oDataUser, sIDKatios, tipoUbicacion, funcionOK, funcionError, m3Ubicacion, resp.M3PItemsWEB);
                });
            }




        }
        //this.UpdateM3ProcesosWithData(oM3Procesos, oM3Data, oDataUser, sIDKatios, tipoUbicacion, funcionOK, funcionError);
    }

    //Cambiar cantidad de m3proceso
    //JAGM 20191018 Se agrega nueva funcionalidad a la cantidad: 
    //1.Se borra el producto de la lista del proceso
    //2. Se agrega de nuevo el producto con la nueva cantidad.
    public async setCantidadV2(oM3Procesos: M3Procesos, idProducto, Lote, iCantidad, IDEnc, oDataUser: any
        , sIDKatios: string, m3Ubicacion: M3Ubicacion, oM3ENCPROMO: Array<M3ENCPROMO>) {
        var oProducto: TypeM3PrdGrp = null;
        var oM3PItemsWEB = new M3PItemsWEB();
        oM3PItemsWEB.dCantidad = iCantidad;
        //JAGM 20191114, Agregar imagen
        var oM3PEncItems = oM3Procesos.M3ENC.find(enc => enc.IdProducto == idProducto && enc.Lote == Lote && enc.ID == IDEnc);
        if (oM3PEncItems) {
            oM3PItemsWEB.PathImagen = oM3PEncItems.PathImage;
        }


        oM3Procesos.M3ENC = oM3Procesos.M3ENC.filter(enc => !(enc.IdProducto == idProducto && enc.Lote == Lote && (enc.ID == IDEnc || enc.IdEncPadre == IDEnc)));

        oProducto = await this.GetProductoBySKU(idProducto, true, oM3Procesos, oDataUser, oM3PEncItems.DISPONIBLE);
        oM3PItemsWEB = this.LoadAdicionales(oM3PItemsWEB, oProducto);
        oM3Procesos = this.addtocart(oM3PItemsWEB, oProducto, null, null, oDataUser, sIDKatios, m3Ubicacion, oM3ENCPROMO, oM3Procesos);
        return { "M3Proceso": oM3Procesos, "M3PItemsWEB": oM3PItemsWEB };
    }

    get_M3ENC_by_idprd_lote(oM3Procesos: M3Procesos, idProducto, Lote): M3PEncItems {
        return oM3Procesos.M3ENC.find(enc => enc.IdProducto == idProducto && enc.Lote == Lote)
    }

    //Obtener cantidad de un encabezado, producto especifico.
    public getCantidad(oM3Procesos: M3Procesos, oProducto: M3PrdGeneral) {
        return oM3Procesos.M3ENC.find(enc => enc.IdProducto == oProducto.SKU && enc.Lote == oProducto.LOTE).M3DET.find(det => det.NombreConcepto == "CANTIDAD").Valor;
    }

    public getCantidadTotal(oM3Procesos: M3Procesos) {
        if (oM3Procesos !== undefined && oM3Procesos.M3ENC !== undefined) {
            oM3Procesos.M3ENC.filter(enc => (+enc.M3DET.find(det => det.NombreConcepto == "CANTIDAD").Valor) > 0).
                reduce((acc, cur) => (acc) + (+cur.M3DET.find(det => det.NombreConcepto == "CANTIDAD").Valor), 0)
        } else {
            return 0;
        }
    }

    //////REGION DE RECEPCION
    //Se agrega atributo de Current cantidad de recepcion
    public MergeRecepYEnc(oM3Procesos: M3Procesos, idRecepcion: number) {
        //oM3PEncItems.M3DET.push(this.LoadM3PDetalle(oM3PrdGeneral.CTBLDPRD, "CTBLDPRD"));
        if (oM3Procesos.M3PRecepcion.length > 0) {
            oM3Procesos.M3PRecepcion.filter(recep => recep.IdRecepcion == idRecepcion).forEach(rec => {
                oM3Procesos.M3ENC.find(enc => enc.ID == rec.IdEnc).M3DET.push(this.LoadM3PDetalle(rec.Cantidad.toString(), "CURCREC"));//CURRENT CANTIDAD RECEPCION
            });
        }
    }

    //Dejar los de talles de la variable: CURCREC en=0, Esto para flujos, donde agrega info procesa y ahÃ­ mismo agrega mÃ¡s.
    public RemoveCurCRec(oM3Procesos: M3Procesos) {
        if (oM3Procesos !== undefined && oM3Procesos != null && oM3Procesos.M3ENC !== undefined && oM3Procesos.M3ENC != null)
            oM3Procesos.M3ENC.forEach(enc => {
                var oDetalle: M3PDetalleItems;
                oDetalle = enc.M3DET.find(det => det.NombreConcepto == "CURCREC");
                if (oDetalle !== undefined && oDetalle != null) {
                    oDetalle.Valor = "0";
                }
            })

    }

    //////FIN REGION DE RECEPCION

    ///////REGION ENTREGA
    //Se agrega atributo de Current cantidad de envio
    public MergeEntpYEnc(oM3Procesos: M3Procesos) {
        //oM3PEncItems.M3DET.push(this.LoadM3PDetalle(oM3PrdGeneral.CTBLDPRD, "CTBLDPRD"));
        if (oM3Procesos.M3PEnvios.length > 0) {
            oM3Procesos.M3PEnvios.forEach(env => {
                var lEnc: Array<M3PEncItems>;
                lEnc = oM3Procesos.M3ENC.filter(enc => enc.IdEnvio == env.IdEnvio);

                if (lEnc !== undefined && lEnc != null) {
                    lEnc.forEach(enc => {
                        enc.M3DET.push(this.LoadM3PDetalle(enc.M3DET.find(det => det.NombreConcepto == "CANTIDAD").Valor, "CURCENT"));//CURRENT CANTIDAD RECEPCION
                    });

                }

            });
        }
    }

    //Dejar los de talles de la variable: CURCREC en=0, Esto para flujos, donde agrega info procesa y ahÃ­ mismo agrega mÃ¡s.
    public RemoveCurCEnt(oM3Procesos: M3Procesos) {
        if (oM3Procesos !== undefined && oM3Procesos != null && oM3Procesos.M3ENC !== undefined && oM3Procesos.M3ENC != null)
            oM3Procesos.M3ENC.forEach(enc => {
                var oDetalle: M3PDetalleItems;
                oDetalle = enc.M3DET.find(det => det.NombreConcepto == "CURCENT");
                if (oDetalle !== undefined && oDetalle != null) {
                    oDetalle.Valor = "0";
                }
            })

    }
    ///////FIN REGION ENTREGA


    /**
     * Promociones que se procesan despues de agregar al carrito
     * @param oM3Procesos 
     * @param oDataUser 
     * @param oM3PItemsWEB 
     * @param oM3Ubicacion 
     * @param EnLinea 
     */
    public async ProcPromoAfterAddToCart(oM3Procesos: M3Procesos, oDataUser: any,
        oM3PItemsWEB: M3PItemsWEB, oM3Ubicacion: M3Ubicacion, EnLinea: boolean) {

        await this.ProcesarObsequios(oDataUser, oM3PItemsWEB, oM3Ubicacion, EnLinea, oM3Procesos);
    }

    /**
     * Procesar promociones despues de finalizar el registro
     * @param oM3Procesos 
     */
    public ProcPromoAfterFinalizar(oM3Procesos: M3Procesos, oM3Ubicacion: M3Ubicacion, oM3ENCPROMO: Array<M3ENCPROMO>, oDataUser: any) {

        this.GenerarPromoCombinada(oM3Procesos, oDataUser);
        this.PromoAfterProceso(oM3Procesos, oM3Ubicacion, oM3ENCPROMO, oDataUser);
    }

    public PromoAfterProceso(oM3Procesos: M3Procesos, oM3Ubicacion: M3Ubicacion, oM3ENCPROMO: Array<M3ENCPROMO>, oDataUser: any) {
        try {
            var opromocionesService = new promocionesService(oDataUser, null);
            var lTiposPromo = new Array<String>();
            var arrPromo: Array<any>;
            var oPromocionProcesada = new PromocionProcesada();
            lTiposPromo.push("AFTER");
            arrPromo = opromocionesService.VerificarPromociones(oM3Procesos, null, oM3Ubicacion, oM3ENCPROMO, lTiposPromo);
            oPromocionProcesada = opromocionesService.ProcesarPromoAfter(arrPromo, oM3Procesos, oM3ENCPROMO);

            if (oPromocionProcesada != null) {
                oM3Procesos.ValorNeto = oPromocionProcesada.PrecioTotal;
                this.AddInfoPromocionesADinamicas(oM3Procesos, oPromocionProcesada);
            }
        } catch {

        }
    }

    /**
     * Agregar informacion de promociones a informacion dinamica del proceso
     * @param oM3Procesos 
     * @param oPromocionProcesada 
     */
    public AddInfoPromocionesADinamicas(oM3Procesos: M3Procesos, oPromocionProcesada: PromocionProcesada) {
        var data = this.GenerarInfoPromocionesProcesadas(oPromocionProcesada, 0);
        if (data != null) {
            var oM3PDinamicas = new M3PDinamicas();
            oM3PDinamicas = this.CreateTuplaDinamica("VAL_PROMOC", oPromocionProcesada.PrecioTotalPromocion.toString())
            oM3Procesos.lM3PDinamicas.push(oM3PDinamicas);

            oM3PDinamicas = this.CreateTuplaDinamica("NOMB_PROMOC", data.NOMBRES)
            oM3Procesos.lM3PDinamicas.push(oM3PDinamicas);

            oM3PDinamicas = this.CreateTuplaDinamica("ID_PROMOC", data.ID)
            oM3Procesos.lM3PDinamicas.push(oM3PDinamicas);
        }


    }

    ///Obtiene el proceso asosiado a un idprestamos
    async get_m3_proceso_by_id_prestamo_async(PostServiceM3: PostServiceM3, id_katios: string, id_prestamo: string) {
        var resp = await PostServiceM3.getM3('M3/getM3ProcesoByIdPrestamo/' + id_katios + '/' + id_prestamo).toPromise();
        return resp;
    }

    public async GetConceptoM3SaldosItemUb(PostServiceM3: PostServiceM3, sIDKatios: string, jData: any) {
        var resp;

        try {
            resp = await PostServiceM3.getWithBodyM3('M3/GetConceptoM3SaldosItemUb/' + sIDKatios, jData).toPromise();
            return resp;
        }
        catch {
            return null;
        }
    }

    /**
     * Agrega o modifica la cantidad de un objeto M3OtClasificaciones dentro dela lista de un Proceso
     * @param product 
     * @param cantidad 
     * @param ioM3Procesos 
     * @param funcionOK 
     */
    public addProductoToOtrasClas(product: TypeM3PrdGrp, cantidad: number, ioM3Procesos: M3Procesos, funcionOK: Function) {
        var oM3Procesos: M3Procesos = ioM3Procesos;
        var oM3OtClasificaciones: M3OtClasificaciones;
        var productUnitSelected: M3PrdGeneral;
        productUnitSelected = product.LoM3PrdGeneral[0];

        let productoExiste = this.validarExistaOtraClasif(oM3Procesos.M3OtClasificaciones, product);
        if (productoExiste) {
            productoExiste.Cantidad = productoExiste.Cantidad + cantidad;
            productoExiste.Valor = +bigDecimal.multiply(productUnitSelected.LoM3PrdLista.PRECIO, productoExiste.Cantidad);
            productoExiste.Orden = this.GetMaxAtributoFromLista(oM3Procesos.M3OtClasificaciones, "Orden") + 1;
        } else {
            oM3OtClasificaciones = new M3OtClasificaciones();
            oM3OtClasificaciones.Cantidad = cantidad;
            oM3OtClasificaciones.IdProducto = productUnitSelected.SKU;
            oM3OtClasificaciones.Nombre = productUnitSelected.NOMBRE1;
            oM3OtClasificaciones.Valor = +bigDecimal.multiply(productUnitSelected.LoM3PrdLista.PRECIO, cantidad);
            oM3OtClasificaciones.ID = this.GetMaxAtributoFromLista(oM3Procesos.M3OtClasificaciones, "ID") + 1;
            oM3OtClasificaciones.Orden = this.GetMaxAtributoFromLista(oM3Procesos.M3OtClasificaciones, "Orden") + 1;

            oM3Procesos.M3OtClasificaciones.push(oM3OtClasificaciones);
        }
        ioM3Procesos = this.recalcularValOtraClasiM3Procesos(ioM3Procesos);
        funcionOK(oM3Procesos);
    }

    /**
     * Elimina un objeto M3OtClasificaciones poniendo su valor y cantidad en cero
     * @param oM3OtClasificaciones 
     * @param ioM3Procesos 
     */
    deleteProductoFromOtrasClas(oM3OtClasificaciones: M3OtClasificaciones, ioM3Procesos: M3Procesos): M3Procesos {
        let productoActual = ioM3Procesos.M3OtClasificaciones.find(x => x.IdProducto == oM3OtClasificaciones.IdProducto);
        if (productoActual) {
            productoActual.Cantidad = 0;
            productoActual.Valor = 0;
        }
        ioM3Procesos = this.recalcularValOtraClasiM3Procesos(ioM3Procesos);
        return ioM3Procesos;
    }

    /**
     * Recalcula el valor de M3Procesos.ValOtraClasi a partir de la sumatoria de los objetos dentro del arreglo M3Procesos.M3OtClasificaciones
     * @param oM3Procesos 
     */
    recalcularValOtraClasiM3Procesos(oM3Procesos: M3Procesos) {
        oM3Procesos.ValOtraClasi = oM3Procesos.M3OtClasificaciones.reduce(function (suma, oM3OtClasificaciones) {
            return suma + oM3OtClasificaciones.Valor;
        }, 0)
        return oM3Procesos;
    }

    /**
     * Valida la existencia de un producto dentro de un la lista de M3OtClasificaciones
     * @param listM3OtClasificaciones 
     * @param product 
     */
    validarExistaOtraClasif(listM3OtClasificaciones: Array<M3OtClasificaciones>, product: TypeM3PrdGrp) {
        let productoExiste = listM3OtClasificaciones.find(x => x.IdProducto == product.LoM3PrdGeneral[0].SKU);
        return productoExiste;
    }

    /**
   * Limpia los detalles y los impuestos de un producto dado en un proceso de devolucion
   * @param productoBorrado 
   * @param procesoDevolucion 
   */
    deletePrdDevolucion(productoBorrado, procesoDevolucion: M3Procesos) {
        let producto = procesoDevolucion.M3ENC.find(x => x.IdProducto == productoBorrado.IdProducto);
        if (producto) {
            producto.M3DET.forEach(det => {
                if (!isNaN(+det.Valor)) {
                    det.Valor = "0";
                }
            });

            producto.M3PImpuestos.forEach(imp => {
                imp.Valor = 0;
                imp.Base = 0;
            });
        }
    }

    /**
     * Ajusta los Valores en caso de encontrar diferencias para poder generar FE
     * @param oM3Procesos 
     */
    ajustadorValoresCFDIFront(oM3Procesos: M3Procesos): M3Procesos {
        let diferencia = 0;
        let totalDescuentos = this.getValorTotalDescuentos(oM3Procesos);
        let totalImporteImpuestos = this.getValorTotalImporteImpuestos(oM3Procesos);

        diferencia = this.oMathTF.round(oM3Procesos.ValorNeto - (oM3Procesos.Valor + totalImporteImpuestos - totalDescuentos), 3);
        if (diferencia != 0) {
            if (totalImporteImpuestos > 0) {
                this.ajustadorImpuestosCFDI(diferencia, oM3Procesos);
            }
            else {
                this.ajustadorDescuentosCFDI(diferencia, oM3Procesos);
            }
        }

        return oM3Procesos;
    }

    /**
     * Retorna el valor total de promociones aplicadas en el proceso en cuestiÃ³n
     * @param oM3Procesos 
     */
    getValorTotalDescuentos(oM3Procesos: M3Procesos): number {
        let totalDescuentos = 0;
        oM3Procesos.M3ENC.forEach(enc => {
            let detallePromo = enc.M3DET.find(x => x.NombreConcepto == "TOTALPROMO");
            if (detallePromo) {
                totalDescuentos += +detallePromo.Valor;
            }
        });

        return totalDescuentos;
    }

    /**
     * Retorna el valor total de impuestos cobrados en el proceso en cuestiÃ³n
     * @param oM3Procesos 
     */
    getValorTotalImporteImpuestos(oM3Procesos: M3Procesos): number {
        let totalImporteImpuestos = 0;
        oM3Procesos.M3ENC.forEach(enc => {
            enc.M3PImpuestos.forEach(imp => {
                totalImporteImpuestos += +imp.Valor;
            });
        });

        return totalImporteImpuestos;
    }

    /**
     * Mueve el valor de un impuesto en 0.01 y su correspondiente base para que cuadre los valores al timbrar la FE
     * @param diferencia 
     * @param oM3Procesos 
     */
    ajustadorImpuestosCFDI(diferencia: number, oM3Procesos: M3Procesos) {
        let ajusto = false;
        for (let enc of oM3Procesos.M3ENC) {
            for (let imp of enc.M3PImpuestos) {
                if (diferencia > 0) {
                    imp.Valor = imp.Valor + 0.01;
                }
                else {
                    imp.Valor = imp.Valor - 0.01;
                }
                imp.Base = imp.Valor / imp.Porcentaje;
                ajusto = true;
                break;
            }
            if (ajusto) {
                break;
            }
        }
    }

    /**
     * Mueve el valor de un descuento en 0.01 para que cuadre los valores al timbrar la FE
     * @param diferencia 
     * @param oM3Procesos 
     */
    ajustadorDescuentosCFDI(diferencia: number, oM3Procesos: M3Procesos) {
        let detalleTotalPromo: M3PDetalleItems;
        for (let enc of oM3Procesos.M3ENC) {
            detalleTotalPromo = enc.M3DET.find(x => x.NombreConcepto == "TOTALPROMO");
            if (detalleTotalPromo && +detalleTotalPromo.Valor > 0) {
                if (diferencia > 0) {
                    detalleTotalPromo.Valor = (+detalleTotalPromo.Valor - 0.01).toString();
                }
                else {
                    detalleTotalPromo.Valor = (+detalleTotalPromo.Valor + 0.01).toString();
                }
                break;
            }
        }
    }

    public getPrdsGeneralFromM3Proceso(PostServiceM3: PostServiceM3, sIdKatios: string, jData: any,
        oFuncionOK: Function, oFuncionErr: Function) {
        PostServiceM3.getWithBodyM3('M3/getPrdsGeneralFromM3Proceso/' + sIdKatios, jData).subscribe(resp => {
            oFuncionOK(resp);
        },
            err => {
                oFuncionErr(JSON.parse(err.error.Message));
            });
    }

}
